// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` .forget-pass-input input::-webkit-password-toggle-button { 
  display: none; 
} 
 .forget-pass-input input::-ms-reveal { 
   display: none; 
 } 
.check-inner{
    padding: 14px 16px;
    border: 1px solid #d9d9d9;
    margin-top: 10px;
} 
.check-inner li .check-iconn,
.check-inner ul, 
.check-inner li{
color: #0a8852;
}
.check-inner ul{
    margin-bottom: 0;
    padding: 0;
}
.input-container {
    position: relative;
    width: 100%;
    max-width: 320px;
}

.input-container input {
    width: 100%;
    padding: 0px;
    font-size: 16px;
    border: 2px solid #ccc;
    border-radius: 5px;
    outline: none;
    height: 3.25rem;
    padding-left: 20px;
}
.footer-innner-reset{
    position: absolute;
    width: 100%;
    bottom: 0;
}

.input-container label {
    display: block;
    position: absolute;
    top: 50%;
    transform: translateY(-54%);
    font-size: 16px;
    color: #888;
    transition: all 0.0s ease;
    pointer-events: none;
    padding-left: 1.25rem;
}

.input-container input:focus + label,
.input-container input:not(:placeholder-shown) + label {
    top: 0px;
    left: 1rem;
    font-size: 14px;
    color: #b4b4b4;
    background: white;
    padding: 0 5px;
}
.input-container input:focus{
    border: 1px solid #10a37f;
}


.password-inner-page input:focus + label{
    color: #10a37f;
}

.input-container .eye-icon{
    position: absolute;
    right: 0px;
    bottom: 1px;
    padding: 12px 16px 12px 16px;
    cursor: pointer;
}
.reset-password{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: calc(100vh -45px);
    background-color: #fff;
}
.reset-password-inner{
    background-color: white;
    border-radius: 8px;
    width: 320px;
    padding-top: 10vh;
}
.reset-password-inner h1{
    font-size: 32px;
    margin: 24px 0 0;
    color: #2d333a;
    width: 320px;
    text-align: center;
    margin-bottom: 15px;
}
.reset-password-inner p{
    font-size: 14px;
    margin-bottom: 20px;
}
.reset-password-inner button{
display: flex
;
    align-items: center;
    justify-content: center;
    position: relative;
    height: 52px;
    width: 320px;
    background-color: rgba(44, 104, 161, 1);
    color: #fff;
    margin: 24px 0 0;
    border-radius: 6px;
    padding: 4px 16px;
    font: inherit;
    border-width: 0;
    cursor: pointer;
    margin-bottom: 20px;
}
.reset-password-inner a{
    border: 0;
    padding: 2px;
    margin: 0;
    line-height: 18px;
    display: inline;
    cursor: pointer;
    vertical-align: baseline;
    font-size: inherit;
    border-radius: 3px;
    color: rgba(44, 104, 161, 1);
    background-color: transparent;
    text-decoration: none;
    font-weight: bold;

}
.back-to{
    text-align: center;
}


.main-singup{
    display: flex;
    align-items: center;
    justify-content: center;
    min-height:calc(100vh-45px) ;
    background-color: #fff;
}
.signup-inner{
background-color: white;
  border-radius: 8px;
    width: 320px;
    padding-top: 10vh;}
.signip-inner h2{
    font-size: 1.5rem;
     font-weight: 600;
      text-align: center;
}
.email-inner{
    margin-top: 1rem;
}
.email-inner label{
   display: block;
    font-size: 1rem;
     font-weight: 500;
     color: #b4b4b4;
}
.email-inner input{
     margin-top: 0.25rem;
      display: block;
       width: 100%;
         border: 1px solid #d1d5db;
          border-radius: 4px;
          padding-left: 1.25rem;
}
.email-inner button{
    display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        height: 52px;
        width: 320px;
        background-color: #10a37f;
        color: #fff;
        margin: 24px 0 0;
        border-radius: 6px;
        padding: 4px 16px;
        font: inherit;
        border-width: 0;
        cursor: pointer;
}
.login-account{
    text-align: center;
    margin-top: 16px;
    margin-bottom: 0;
    font-size: 14px;
    color: #000;
}
.login-account a{ 
    font-weight: 400;
    text-decoration: inherit;
    color: #10a37f;
    padding: 4px;
}
.or-inner{
    display: flex;
     align-items: center;
      margin: 1rem 0;
}
.or-inner hr{
flex-grow: 1;
 border: none;
  border-top: 1px solid #c2c8d0;
  flex: 1 0 auto;
  margin: 0;
}
.or-inner span{
 margin: 0 0.5rem;
  color: #000;
  text-align: center;
  flex: .2 0 auto;
  margin: 0;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 400;
}
.continue-inner-page{
    display: grid;
     gap: 0.5rem;
}
.continue-inner-page button{
    position: relative;
    width: 320px;
    border: 1px solid #c2c8d0;
    border-radius: 6px;
    font-size: 16px;
    align-items: center;
    background-color: #fff;
    height: 52px;
    transition: box-shadow .15 ease-in-out, background-color .15s ease-in-out;
    cursor: pointer;
    color: #2d333a;
    margin-bottom: 8px;
    display: flex;
    outline: 0;
    padding: 0 8px 0 18px;
    cursor: pointer;
    color: #2d333a;
    font-size: 16px;
    gap: 10px;
    font-family: OpenAI Sans, SF Pro, -apple-system, BlinkMacSystemFont, Helvetica, sans-serif;
}
.continue-inner-page button img{
width: 35px;
 height: 35px;
  margin-right: 0.5rem;
}
.signup-inner h2{
    font-size: 32px;
    margin: 24px 0 0;
    color: #2d333a;
    width: 320px;
    text-align: center;
}



.password-inner-main{
    display: flex;
      justify-content: center;
       min-height: 95vh;
        background-color: #fff;
        padding-top: 15vh;}
.password-inner-page{
background-color: white;
  border-radius :8px;
    width:320px;

}

.login-password{
     text-align: center;
     font-weight: 500 !important;
    font-size: 32px !important;
    margin-top: 0;
    color: #2d333a;
}
.password-main-div{
 margin-top: 1rem;
}
.email-edit{
border: 1px solid #d1d5db;
  border-radius: 4px;
   margin-top: 0.5rem;
   min-height: 52px;
   height: auto;
   display: flex;
       align-items: center;
       justify-content: space-between;
       padding: 0 16px;
       background-color: #f1f2f3;
       margin-bottom: 12px;
}
.email-edit span{
color: #2d333a;
 float: left;
}

.email-edit .edit-color{
    color: #10a37f;
}
.password-align{
    display: block;
     margin: 1rem auto 0;
      background: none;
       border: none;
        color: #10b981;
         cursor: pointer;
}
.password-main-div .password-align{
    text-align: left;
    font-weight: normal;
}

.password-main-div input{
    display: block;
     width: 100%;
      padding: 0.5rem;
       border: 1px solid #d1d5db;
        border-radius: 4px;
        width: 100%;
        padding: 0;
        border: 1px solid #d1d5db;
        border-radius: 4px;
        height: 52px;
    padding-left: 1.25rem;
}
.password-main-div .link-inner{
    display: block;
     margin: 1rem auto 0;
      background: none;
       border: none;
        color: #10b981;
         cursor: pointer;
}
.password-main-div button{
    margin-top: 24px;
     width: 100%;
      background-color: #10a37f;
       color: white;
        padding: 0.5rem;
        border-radius: 4px;
         border: none;
          cursor: pointer;
          display: flex;
              align-items: center;
              justify-content: center;
              position: relative;
              width: 100%;
              min-height: 52px;
              font-size: 16px;
              font-weight: 400;
              outline: none;
              cursor: pointer;
}
.password-main-div a{
     display: block;
      margin: 1rem auto 0;
       background: none;
        border: none;
         color: #10a37f;
          cursor: pointer;
           text-align: center;
           border: 0;
    padding: 2px;
    background-color: transparent;
    cursor: pointer;
    text-decoration: none;
    font-size: 14px;
    font-weight: 700;
}
.account-login{
    text-align: center;
     font-size:14px;
      color: #2d333a;
       margin-top : 16px;
       font-weight: 400;
}
.account-login a{
     color: #10a37f;
     text-decoration: none;
     font-size: 14px;
     font-weight: 400;
}
.or-hr-page{
    display: flex;
     align-items: center;
      margin: 24px 0;
}
.or-hr-page hr{
flex-grow: 1;
 border: none;
  border-top: 1px solid #c2c8d0;
  font-size: 12px;
  font-weight: 500;
}
.or-hr-page span{
    margin: 0 0.5rem;
     color: #2d333a;
     font-size: 12px;
     font-weight: 500;
}
.google-inner-part{
    display: grid;
     gap: 0.5rem;
}
.google-inner-part button{
    position: relative;
    width: 320px;
    border: 1px solid #c2c8d0;
    border-radius: 6px;
    font-size: 16px;
    align-items: center;
    background-color: #fff;
    height: 52px;
    transition: box-shadow .15 ease-in-out, background-color .15s ease-in-out;
    cursor: pointer;
    color: #2d333a;
    margin-bottom: 8px;
    display: flex;
    outline: 0;
    padding: 0 8px 0 18px;
    cursor: pointer;
    color: #2d333a;
    font-size: 16px;
    gap: 10px;
    font-family: OpenAI Sans, SF Pro, -apple-system, BlinkMacSystemFont, Helvetica, sans-serif;
}
.google-inner-part button img{
    width: 20px;
     height: 20px;
      margin-right: 0.5rem;
}
.term-part{
     text-align: center;
      font-size: 0.875rem;
       color: #6b7280;
       margin: 0;
       height: 45px;
}
.term-part a{
     color: #10b981;
      text-decoration: none;
      margin: 0 10px;
      font-size: 14px;
      font-weight: 500;
}
.footer-innner{
    position: absolute;
    width: 100%;
    bottom: 0;
}
.footer-innners {
    position: absolute;
width: 100%;
}



.verifaction-inner-part{
    display: flex;
      justify-content: center;
       min-height: 85vh;
        background-color: #fff;
}
.verification-content{
      border-radius: 8px;
        width: 21.25rem;
        padding-top: 15vh;
}
.verification-h2{
    font-size: 2rem;
     font-weight: 500;
      text-align: center;
      margin: 0;
}
.verifaication-para{
    text-align: center;
     color: #4b5563;
      font-size: 1rem;
      font-weight: 400;
}
.verifaction-inner-input{
    margin-top: 1rem;
}
.verifaction-inner-input input{
    display: block;
     width: 100%;
      padding: 0.5rem;
       border: 1px solid #d1d5db;
        border-radius: 4px;
    }
    .verifaction-inner-input input:focus + label{
        color: #10a37f;
        font-weight: 500;
    }
    
    .continue-btn{
        margin-top: 24px;
        width: 100%;
         background-color: #10a37f;
          color: white;
           padding: 0.5rem;
           border-radius: 4px;
            border: none;
             cursor: pointer;
             display: flex;
                 align-items: center;
                 justify-content: center;
                 position: relative;
                 width: 100%;
                 min-height: 52px;
                 font-size: 16px;
                 font-weight: 400;
                 outline: none;
                 cursor: pointer;
    }
    .verifaction-inner-input .input-containers {
        position: relative;
        width: 100%;
        max-width: 20rem;
        
    }

    .password-inner-page input:focus + label{
        color: #10a37f;
    }
    
    .verifaction-inner-input .input-containers input{
        padding: 0;
        padding-left: 20px;
    }
    .resend-btn{
        display: block;
         margin: 25px auto 0;
          background: none;
           border: none;
            color: #10b981;
             cursor: pointer;
              text-align: center;
font-size: 1rem;
color: #0d0d0d;
font-weight: 400;
    }
    .terms-inner{
        text-align: center;
         font-size: 0.875rem;
          color:#6b7280;
           margin-top: 3rem;
    }
    .terms-inner a{
color: #10b981;
 text-decoration: none;

    }



    .about-inner-page{
display: flex;
 justify-content:center;
   min-height: 85vh;
    background-color: #fff;
    }

    .about-inner-content{
          border-radius: 8px;
          width: 21.25rem;
          padding-top: 15vh;
    }
    .about-inner-content h2{
        text-align: center;
    font-size: 30px;
     font-weight: 600;
      margin-bottom: 20px;
    }
    .about-inner-form input{
width: 100%;
 padding: 10px;
  margin-bottom: 16px;
   border: 1px solid #ccc;
    border-radius: 4px;
    }

    .about-inner-form p{
        font-size: 12px;
         color: #6b7280;
          margin-bottom:16px;
    }
    .about-inner-form p a{
color: #2563eb;
 text-decoration: underline;
    }

    .about-inner-form button{
        margin-top: 24px;
        width: 100%;
         background-color: #10a37f;
          color: white;
           padding: 0.5rem;
           border-radius: 4px;
            border: none;
             cursor: pointer;
             display: flex;
                 align-items: center;
                 justify-content: center;
                 position: relative;
                 width: 100%;
                 min-height: 52px;
                 font-size: 16px;
                 font-weight: 400;
                 outline: none;
                 cursor: pointer;
    }






.sidebar-content-other{
    display: flex;
}
.home-page-content-inner{
    width: 100%;
}
.sidebar-content-inner{
width: 277px;
border: 1px solid red;
}




















.first-change-color{
width: 40px;
    height: 40px;
    text-align: center;
    background: #0e5f99;
    border-radius: 50px;
    line-height: 38px;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
    margin-left: 10px;
}

            /* home-icos-btn, home-inner-icons → HomeHeader1.css */
            .login-inner-page button{
                width: 113px;
                height: 43px;
                background-color: rgba(2, 137, 214, 1);
                font-family: 'Figtree', sans-serif;
                font-size: 13px;
                font-weight: 700;
                text-align: center;
                color: rgba(255, 255, 255, 1);
                border: none;
            }
            .grade-inner-page{
                border: 1px solid #d1d5db;
                width: 100%;
                height: 158px;
                padding: 10px 15px;
                background-color: rgba(252, 252, 252, 1);
                box-shadow: 0.5px 0.5px 4px 0px rgba(0, 0, 0, 0.25);
                border-radius: 15px;
            

            }

            .pngtree{
                width: 35px;
                height: 35px;
                margin-bottom: 15px;
            }
            .select-page-inner{
                border: none;
                font-family: 'Figtree', sans-serif;
                font-size: 16px;
                font-weight: 500;
                color: rgba(113, 113, 113, 1);
                width: 149px;
                height: 36px;
                
                
            }
            .select-page-inner option{
                font-family: 'Figtree', sans-serif;
                font-size: 13px;
                font-weight: 500;
                padding-left: 10px;
            }
            .select-page-inner:focus-visible{
                outline: none;
            }
            .grade-select{
                margin-top: 15px;
                font-family: 'Figtree', sans-serif;
                font-size: 14px;
                font-weight: 500;
                color: rgba(113, 113, 113, 1);
            }

            .help-with-inner{
                text-align: center;
            }
            .content-inner-page{
                padding-top: 150px;
            }
            .input-box-inner{
                text-align: center;
                padding-top:130px ;
            }
            .input-box-inner input{
width: 717px;
height: 65px;
padding: 0px 20px;
background-color: rgba(252, 252, 252, 1);
box-shadow: 0.5px 0.5px 4px 0px rgba(0, 0, 0, 0.25);
border-radius: 15px; 
font-family: 'Figtree', sans-serif;
font-size: 15px;
font-weight: 500;
color: rgba(79, 79, 79, 1);
border: #d1d5db;
}
.input-box-inner input:focus-visible{
    outline: none;
}

.help-with-inner h4{
    font-family: 'Figtree', sans-serif;
    font-size: 19px;
    font-weight: 500;
    color: rgba(113, 113, 113, 1);
}

.help-with-inner h2{
    font-family: 'Figtree', sans-serif;
    font-size: 33px;
    font-weight: 700;
    color:rgba(46, 46, 46, 1);
    margin-bottom: 30px;
}

.input-box-inner button{
    width: 97px;
    height: 38px;
    background-color: rgba(2, 137, 214, 1);
    border-radius: 12px;
    border: none;
    font-family: 'Figtree', sans-serif;
    font-size: 15px;
    font-weight: 600;
    color: rgba(255, 255, 255, 1);
    position: relative;
    right: 120px;
    bottom: 1px;
}
.input-box-inner button img{
    width: 26px;
    height: 26px;
    margin-top: -2px;
}

.change-pass-para{
    text-align: center;
}
.new-password-inner{
    margin-bottom: 12px;
}
div.new-password-inner input{
    border: 1px solid #686868;
}
div.reenter-pass input:focus + label,
div.new-password-inner  input:focus + label{
    color: #10a37f;
    font-weight: 500;
}
/* header-inner → HomeHeader1.css */
.home-page-content-inner .shrink,
.header-inner .shrink{
    width: calc(100% - 277px);
}









@media only screen and (max-width: 480px) {
    .content-inner-page {
        padding-top: 50px;
    }
    .help-with-inner h2 {
        font-size: 28px;
    }
    .grade-inner-page {
        margin-bottom: 15px;
    }
    .input-box-inner input {
        width: 100%;
    }
    .input-box-inner {
        padding-top: 50px;
    }
    .input-box-inner button {
        position: relative;
        right: -93px;
        bottom: 51px;
    }
}



@media only screen and (max-width: 991px) {
    .input-box-inner button {
        position: relative;
        right: -292px;
        bottom: 50px;
    }
.grade-inner-page {
    margin-bottom: 15px;

}
.content-inner-page {
    padding-top: 100px;
}

}




  .header {
    width: 100%;
    height: var(--app-header-height, 85px);
    min-height: var(--app-header-height, 85px);
    max-height: var(--app-header-height, 85px);
    background: #fff;
    color: #000;
    display: flex;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    box-sizing: border-box;
    overflow: visible;
    transition: transform 0.3s ease-in-out, margin-left 0.3s ease, width 0.3s ease;
}

/* .menu-icon → HomeHeader1.css */
.sidebar {
    width: 277px;
    height: 100vh;
    background: #fff;
    color: white;
    position: fixed;
    left: -277px;
    top: 0;
    transition: left 0.3s ease-in-out;
}

/* .sidebar ul {
    list-style: none;
    padding: 0;
    padding-top: 14px;
} */
/* .sidebar ul li:hover{
    background-color: #ececec;
    border-radius: 7px;
} */
/* .sidebar ul li {
    padding: 5px 10px 10px 8px;
    cursor: pointer;
    color: #000;
} */
.chat-box-text{
    display: inline-block;
    padding: 7px 14px;
    border-radius: 50px;
    background: #ececec;
}
/* header-inner .shrink → HomeHeader1.css */
.content {
    /* padding: 80px 20px; */
    transition: transform 0.3s ease-in-out;
    width: 100%;
}


.sidebar.open {
    left: 0;
}

.content.shrink {
    transform: translateX(277px);
}

.header.shrink {
    transform: translateX(277px);
}
.sidebar-content-other {
    display: flex;
    transition: all 0.3s ease;
    overflow: visible;
  }

  .home-page-content-inner > .content,
  .home-page-content-inner > .home-inner-page,
  .home-page-content-inner #content.content {
    overflow-x: hidden;
  }
  
  .sidebar {
    width: 80px;
    transition: width 0.3s ease;
    overflow: hidden;
  }
  
  .sidebar.open {
    width: 277px;
    padding-top: 32px;
    padding-left: 20px;
    padding-right: 20px;
  }
  
 
  .sidebar  .menu-icon{
    margin-top: 9px;
    width: 26px;
    height: 26px;
  }
  .home-page-content-inner {
    flex-grow: 1;
    transition: margin-left 0.3s ease;
  }
  
  .sidebar-open .home-page-content-inner {
    margin-left: 277px;
  }
  
  .content {
    width: 100%;
    transition: margin-left 0.3s ease;
    /* height: 100vh; */
  }
  
  .sidebar-open .content {
    margin-left: 0;
  }






  /* ..........................sidebar new css......................... */
.sidebar-inner-image{
display: flex;
justify-content: space-between;
margin-bottom: 25px;
}
.collapsible{
    font-family: 'Figtree', sans-serif;
    color:rgba(44, 104, 161, 1);
    font-weight: 700;
    font-size: 13px;
    line-height: 29px;
    margin-bottom: 0;
    margin-left: 10px;
  }
.sidebar-inner-image h2{
    font-family: 'Figtree', sans-serif;
    color: rgba(0, 0, 0, 1);
    font-weight: 700;
    font-size: 17px;
    line-height: 29px;
    margin-bottom: 0;
    margin-top: 8px;
        text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}
.books-colla img{
    width: 19.11px;
    height: 20px;
    margin-top: 5px;
}
.books-colla{
    display: flex;
    margin-top: 25px;
    margin-bottom: 10px;
    cursor: pointer;
  }

  .sidebar-inner-layout input{
    width: 100%;
    height: 42px;
    border: 1.5px solid rgba(223, 223, 223, 1);
    border-radius: 12px;
    padding-left: 40px;
    font-family: 'Figtree', sans-serif;
    color: rgba(122, 122, 122, 1);
    font-weight: 500;
    font-size: 12px;
    line-height: 29px;
  }
  .sidebar-inner-layout .search-icon{
    width: 14.62px;
    height: 14.62px;
    top: 107px;
    bottom: auto;
    left: 32px;
    position: absolute;
  }
  
  .Sdesign{
    width: 8px;
    height: 8px;
  }
  .Kdesign{
    width: 8px;
    height: 8px;
    margin-left: 5px;
  }
  .SKdesign{
  position: absolute;
  right: 38px;
  top: 101px;
  }
.full-unit h4{
    font-family: 'Figtree', sans-serif;
    color: rgba(113, 113, 113, 1);
    font-weight: 600;
    font-size: 13px;
    line-height: 29px;
    margin-bottom: 0;
}
  .full-unit ul{
    padding: 0;
  }
  .full-unit ul p{
    padding: 0;
    font-family: 'Figtree', sans-serif;
    color: rgba(113, 113, 113, 1);
    font-weight: 500;
    font-size: 12px;
    line-height: 29px;
    
    margin-bottom: 0px;
  }
  .sidebar-one.open{
    border-right: 1px solid rgba(223, 223, 223, 1);
  }
  /* logo-scsc, button-login-inner → HomeHeader1.css */

.lorem-inner{
    text-align: center;
}
.lorem-inner h2{
    color:rgba(0, 0, 0, 1);
font-family: 'Figtree', sans-serif;
font-weight: 700;
font-size: 48px;
line-height: 60px;
}
.unit-plan{

    border: 1px solid rgba(223, 223, 223, 1);
    height: 45px;
    border-radius: 15px;
    margin-top: 30px;
    /* box-shadow: 0.3px 0.3px 4px 0px rgba(0, 0, 0, 0.25); */
}
.textareacustome {
    height: 45px !important;
}
.green-box{
    border: 1px solid #45D43D;
}
.homme-outer{
    height: calc(100vh - var(--app-header-height, 85px));
    padding: 100px 20px 20px 20px;
}
.homme-outer-new {
     padding: 75px 20px 20px 20px;
}
.unit-plan{
    display: flex;
    justify-content: space-between;
    padding: 8px 20px;
    background-color: rgba(44, 104, 161, 1);
    color: #fff;
}
/* home-inner-icons → HomeHeader1.css */
.unit-plan h3{
   
    font-family: 'Figtree', sans-serif;
    font-weight:400;
    font-size: 16px;
    line-height: 29px;
    margin-bottom: 0;
}
.unit-plan img{
    width: 30px;
    height: 30px;
}
.button-next button{
    min-width: 97px;
    height:43px;
    background-color: rgba(223, 223, 223, 1);
    color: #fff;
    border: 1px solid rgba(223, 223, 223, 1);
    border-radius: 12px;
    font-family: 'Figtree', sans-serif;
    font-weight: 600;
    font-size: 15px;
    margin-top: 30px;
    padding-left: 15px;
    padding-right: 15px;
}
.button-next button i{
margin-left: 10px;
font-size: 17px;
}
.content-inner2 {
    height: 200px;
    width: 100%;
   padding: 0 205px;
}
.content-inner2 h4{
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 16px;
    line-height: 29px;
    color: rgba(113, 113, 113, 1);
  
    margin-bottom: 0;
}
.simplearrow{
    font-size:15px;
margin-left:7px;

}
.content-inner2 textarea{
    width: 100%;
    height: 60px;
    padding-left: 25px;
    color:rgba(113, 113, 113, 1) ;
    flex: 1 1;
      resize: none;
        min-height: 35px;
      max-height: 200px;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 15px;
      outline: none;
      overflow-y: auto;
}

.content-inner2 textarea:focus-visible{
outline: none;
}
.content-inner2 textarea{
outline: none;
border: none;
border-bottom: 0.8px solid rgba(223, 223, 223, 1)
}

.shrink .content-inner2 img{
    Width: 15.27px;
    Height: 15.27px;
    position: absolute;
    top: 9px;
}
.edit-content-answer{
    position: relative;
}
.content-inner2 img{
    Width: 15.27px;
    Height: 15.27px;
    position: absolute;
    top: 24px;
}
div.input-container  input:-webkit-autofill {
    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;
  }
  .button-next button.back-btns{
    background: #A7A7A7;
    text-align: left;
    margin-right: 12px;
  }
.button-next .back-btns i{
    margin-right: 10px;
}










/* button-login-inner → HomeHeader1.css */

@media only screen and (max-width: 480px) {
.output-container .input-field-btn button {
        right: 35px;
    }
    .output-container .input-field-btn button {
    width: 80px;
    }
    .header.shrink {
        transform: translateX(0px);
    }
    /* header-inner .shrink .dashboard-btn → HomeHeader1.css */
    .home-page-content-inner .shrink, .header-inner .shrink {
        width: 100%;
    }
    .content.shrink {
        transform: translateX(0px);
    }
    .homme-outer {
        padding: 20px 20px 20px 20px;
    }
    .sidebar.open {
        z-index: 9999;
    }
    /* logo-scsc, button-login-inner button → HomeHeader1.css */
.lorem-inner h2 {
    font-size: 32px;
    margin: 0;
}
.sidebar.open {
    width: 250px;
}
}



.image-inner img,
.school-content-page img{
    width: 327.45px;
    position: absolute;
}
div.input-container input:focus {
    border: 1px solid rgba(44, 104, 161, 1);
}
.signup-outer-pagess,
.school-outer-pages{
    width: 330px;
    height: auto;
 
}
.or-inner hr {
border: 1px solid rgba(194, 200, 208, 1);
}
.schoo-outer{
    height: 95vh;
    align-items: center;
    display: flex;
    justify-content: center;
}
.school-outer-pages select{
    width: 100%;
    height: 55px;
    margin-bottom: 25px ;
    border: 1px solid rgba(194, 200, 208, 1);
    border-radius: 6px;
    color: rgba(45, 51, 58, 0.45);
    padding-left: 17px;
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 17px;
    line-height: 29px;

}
.school-outer-pages .input-container{
    position: relative;
    width: 100%;
    max-width: 100%;
     color: rgba(45, 51, 58, 0.45);
     font-family: 'Figtree', sans-serif;
     font-weight: 500;
     font-size: 17px;
     line-height: 29px;
}
p.term-part a {
    color: rgba(44, 104, 161, 1);
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 29px;

}
.school-outer-pages button{
    border: none;
    background: rgba(44, 104, 161, 1);
    color: #fff;
    border-radius: 5px;
    margin-top: 25px;
    font-family: 'Figtree', sans-serif;
    font-weight: 700;
    font-size: 13px;
    line-height: 29px;
    margin-bottom: 35px;
}

.school-outer-pages h2{
    text-align: center;
    font-family: 'Figtree', sans-serif;
    font-weight: 600;
    font-size: 33px;
    line-height: 29px;
    margin-bottom: 30px;
}
.verification-code{
    text-align: center;
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 21px;
    color: #2D333AA6;
    margin-bottom: 30px;
}
div.forget-passw h2{
    margin-bottom: 15px;
}
div.forget-passw button{
    margin-bottom: 18px;
}
.forget-passw .login-account{
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 29px;
    margin-bottom: 30px;
        cursor: pointer;
}
.input-container input{
    border: 1px solid rgba(194, 200, 208, 1);
    height: 55px;
}
.signup-outer-pagess .input-container {
    position: relative;
    max-width: 100%;
}
.signup-outer-pagess .continue-inner-page .continue-btn,
.signup-outer-pagess .email-inner .continue-btn{
    width: 100%;
    height: 54px;
    font-family: 'Figtree', sans-serif;
    font-weight: 700;
    font-size: 13px;
    line-height: 29px;
    border: none;
    background: rgba(44, 104, 161, 1);
    color: #fff;
    border-radius: 5px;
    text-transform: uppercase;
}
.signup-outer-pagess h2{
    text-align: center;
    font-family: 'Figtree', sans-serif;
    font-weight: 600;
    font-size: 33px;
    line-height: 29px;
    margin-bottom: 25px;
}
.signup-outer-pagess .input-container input{
    height: 55px;
}
/* Hide browser's password/credentials icon - sirf apna Eye icon dikhe */
.signup-outer-pagess .input-container input[type="password"]::-webkit-credentials-auto-fill-button,
.signup-outer-pagess .input-container input[type="password"]::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    position: absolute;
    right: 0;
    pointer-events: none;
}
.signup-outer-pagess .input-container input[type="password"]::-webkit-textfield-decoration-container {
    display: none;
}
.signup-outer-pagess .input-container input[type="password"]::-webkit-password-toggle-button {
    display: none;
}
.signup-outer-pagess .input-container input[type="password"]::-ms-reveal {
    display: none;
}
.signup-outer-pagess .continue-inner-page button{
width: 100%;
height: 55px;
}
.signup-outer-pagess .or-inner span,
.signup-outer-pagess .login-account a,
.signup-outer-pagess .login-account {
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 29px; 
}
.signup-outer-pagess .login-account{
    color:  rgba(45, 51, 58, 1);
}
.signup-outer-pagess .login-account a{
    color: rgba(44, 104, 161, 1);
}

.signup-outer-pagess .continue-inner-page{
    margin-bottom: 35px;
}
.signup-outer-pagess .set-your{
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 15px;
    line-height: 29px; 
    color: rgba(45, 51, 58, 0.65);
    text-align: center;
    margin-bottom: 20px;
}
.signup-outer-pagess h3{
text-align: center;
font-family: 'Figtree', sans-serif;
font-weight: 600;
font-size: 33px;
line-height: 29px;
margin-bottom: 17px;
}
.email-cont{
    margin-top: 15px;
}

.forget-pass-input{
    margin-top: 20px;
}
.span-forg{
    font-family: 'Figtree', sans-serif;
    font-weight: 500;
    font-size: 12px;
    line-height: 29px; 
    color: #2C68A1;
    margin: 0;
}
.google-continue{
color: #2D333A!important;
font-family: 'Figtree', sans-serif!important;
font-weight: 500!important;
font-size: 15px!important;
line-height: 29px!important; 
}
.login-pass-outer .email-inner button {
    margin-top: 10px;
}
.comfirm-pass{
    margin-top: 20px;
    margin-bottom: 20px;
} 
.school-outer-pages .css-t3ipsp-control,
.school-outer-pages .css-13cymwt-control{
    height: 55px;
    border-radius: 6px;
border: 1px solid #C2C8D0;
padding-left: 10px;
margin-bottom: 20px;
color: rgba(45, 51, 58, 0.45);
font-family: "Figtree";
font-size: 17px;
font-style: normal;
font-weight: 500;
line-height: 29px;
}
.school-content-page{
    padding: 15px 40px;
}

.generate-inner img{
    width: 15px;
    height: 15px;
}
.generate-inner{
    display:flex;
    margin-top: 20px;
}
.generate-inner h2{
    color: #2C68A1;
font-family: "Figtree";
font-size: 13px;
font-style: normal;
font-weight: 700;
margin: 0px 0px 0px 7px;
}
.output-container{
    height: auto;
    width: 100%;
    padding: 20px 160px 0 225px;
}
.write-question{
border-radius: 12px;
background: #F4F4F4;
padding: 15px 15px 15px 15px;
}
.write-question p{
    font-family: 'Figtree', sans-serif;
    color: #0D0D0D;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 23px;
    letter-spacing: 0.45px;
    margin: 0;

}
.write-question ol.write-question-list{
    padding-left: 17px;
}
.write-question ol.write-question-list li{
    color: #0D0D0D;
    font-family: 'Figtree', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    line-height: 29px;
    letter-spacing: 0.45px;
}

.sidebar-one .sidebar-inner-layout{
    display: none;
}
/* .sidebar.sidebar-one{
    width: 0;
}
.sidebar.sidebar-one.open{
    width: 25%;
} */
.inner-images{
    display: flex;
    padding-top: 20px;
    padding-bottom: 30px;
}
.inner-images .dislike-image{
    width: 18px;
    height: 18px;
    margin-left: 12px;
    margin-top: -1px;   
}
.inner-images .group-image{
    width: 15.456px;
    height: 15.455px;
}


.input-field-btn textarea{
    width: 100%;
    height: 104px;
    border-radius: 15px;
border: 1px solid #DCDCDC;
padding: 30px 130px 30px 30px;
box-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.25);
flex: 1 1;
      resize: none;
        min-height: 95px;
      max-height: 200px;
      border: 1px solid #ccc;
      border-radius: 8px;
      font-size: 15px;
      outline: none;
      overflow-y: auto;
}
.input-field-btn{
    position: relative;
}
.input-field-btn button{
 height: 38px;
    border-radius: 12px;
    background: #2C68A1;
    color: #FFF;
    font-family: 'Figtree', sans-serif;
    font-size: 15px;
    font-style: normal;
    font-weight: 600;
    line-height: 29px;
    letter-spacing: 0.45px;
    border: none;
    bottom: 30px;
    display: flex;
    right: 35px;
    padding: 5px 10px;
    gap: 5px;
    justify-content: center;
}
.input-field-btn button img{
    width: 26px;
    height: 26px;
}
.input-text-inner-field{
    padding-top: 10px;
}

.input-text-inner-field p{
    margin: 0;
    color: #595959;

font-family: "Figtree";
font-size: 15px;
font-style: normal;
font-weight: 400;
line-height: 29px;
}
.buttons-cont-flex{
    display: flex;
    margin-top: 20px;
    margin-bottom: 20px;
}
.buttons-cont-flex button{
    width: 112px;
height: 38px;
border-radius: 12px;
border: 1px solid #2C68A1;
color: #2C68A1;
font-family: Figtree;
font-size: 14px;
font-style: normal;
font-weight: 500;
line-height:17px; 
letter-spacing: 0.42px;
}

.buttons-cont-flex .assignment{
margin-left: 10px;
margin-right: 10px;
}
.Given-answer{
    padding: 15px 15px 15px 0px;
}
.Given-answer p{
    margin: 0;
}
.school-pages-inner .email-inner .input-container span{
    position: absolute;
    right: 15px;
    bottom: 18px;
}
.left-span{
    margin-left: 70px;
}
.high-light-btn {
    background-color:#3498db !important;
    color:white !important;
}

.ScrollBar {
  height: 70%;
  overflow-y: auto;
  padding-right: 10px;

  /* Firefox scrollbar styling */
  scrollbar-width: none;                    /* Options: auto | thin | none */
  scrollbar-color: #aaa transparent;        /* Thumb | Track */
}

/* Chrome, Safari, Edge (WebKit) */
.ScrollBar::-webkit-scrollbar {
  width: 0px;
}

.ScrollBar::-webkit-scrollbar-track {
  background: transparent;
}

.ScrollBar::-webkit-scrollbar-thumb {
  background-color: #aaa;
  border-radius: 4px;
  border: 2px solid transparent; /* Optional for spacing inside track */
  background-clip: content-box;
}



.login-pass-iner-outer .schoo-outer {
    margin-top: 75px;
}

.login-pass-iner-outer .signup-outer-pagess h2 {
    font-size: 29px;
}







.chat-container {
      flex: 1 1;
      overflow-y: auto;
      padding: 20px;
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

   

    .input-wrapper {
      display: flex;
      padding: 16px;
      border-top: 1px solid #ddd;
      background-color: #fff;
    }

  



@media screen and (max-width: 480px) {
    .output-container{
    padding: 20px;
}
.output-container .input-field-btn{
    position: absolute;
    bottom: auto;
}
.input-field-btn button {
    bottom: 36px;
    right: 13px;
}
.input-field-btn textarea {
    padding: 30px 118px 30px 30px;
}

/* button-login-inner → HomeHeader1.css */
    .content-inner2 {
        padding: 0 10px;
}
.content-inner2 img {
    top: 8px;
}
}
@media screen and (max-width: 991px) {
.output-container .input-field-btn button {
        right: 58px;
    }
    .output-container .input-field-btn {
        position: absolute;
        bottom: auto;
    }
    .output-container .input-field-btn button {
    width: 90px;
    }


.output-container {
    padding: 20px;
}
.content-inner2 img {
    top: 8px;
}
.input-field-btn {
    position: absolute;
    width: 95%;
    bottom: 29px;
}
div.choose-organisaton {
    width: 100%;
}
div.organisaton-container {
    flex-direction: column;
}
}
@media screen and (max-width: 1200px) {

    .output-container .input-field-btn button {
        right: 58px;
    }
    .output-container .input-field-btn {
        position: absolute;
        bottom: auto;
    }
    .output-container .input-field-btn button {
    width: 90px;
    }
.output-container {
    padding: 20px;
}
.input-field-btn {
    position: absolute;
    width: 100%;
    bottom: 29px;
}
.output-outer-content {
    min-height: calc(100vh - 200px);
}
.unit-plan h3 {
    color: rgba(0, 0, 0, 1);
    font-family: 'Figtree', sans-serif;
    font-weight: 600;
    font-size: 13px;
    line-height: 29px;
}
.content-inner2 {
    height: 200px;
    width: 100%;
    padding: 0 20px;
}
.input-field-btn button {
 right: 15px;
}
.input-field-btn textarea {
    padding: 30px 120px 30px 30px;
}
/* button-login-inner → HomeHeader1.css */
}



/* -------------------Ram------------------ */

/* logomain, logo-scsc.logomain → HomeHeader1.css */
.welcome-teaching{
    margin-left: 277px;
    width: calc(100% - 277px);
    padding: 27px;
    background: #2C68A1;
    color: #fff;
    border-radius: 6px;
    max-width: 1350px;
     font-family: 'Figtree', sans-serif;
     
}

.welcome-main-teaching{
    padding: 20px 20px 0px 20px;
       flex: 1 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}



.output-container.output-tft .Given-answer{
     font-family: 'Figtree', sans-serif;
    border-radius: 6px;
    background: #F4F4F4;
    padding: 15px;
    margin-bottom: 10px;
    width: 90%;
    display: inline-block;
    box-shadow: 0px 4px 4px 0px #00000040;

}

.output-container.output-tft .write-question {
    border-radius: 6px;
    background: #2C68A1;
    padding: 15px 15px 15px 15px;
    margin-bottom: 10px;
    width: 90%;
    
}
 .output-container.output-tft .write-question.message-inner{
    color:#fff
}
.output-container.output-tft {
   padding: 0px 25px;
}
.main-conatiner-user{
    width: 100%;
    display: inline-flex;
    justify-content: end;
}
.main-conatiner-user .message-inner-div{
    color:#fff;
     font-size: 17px;
    font-weight: 400;
}
.main-conatiner-user .message-content-inner{
     border-radius: 12px;
    background: #2C68A1;
    padding: 15px 15px 15px 15px;
    margin-bottom: 10px;
    border: 1px solid #DFDFDF;
   max-width: 90%;
       color: #fff;
}

.given-container{
    max-width: 90%;
}
.given-container .message-inner-div {
    color: rgb(13, 13, 13);
    font-size: 17px;
    font-weight: 400;
}

.given-container .message-inner-div{
  border-radius: 12px;
    background: #F4F4F4;
    padding: 15px;
    margin-bottom: 10px;
    display: inline-block;
    box-shadow: 0px 0px 0px 0px #00000040;
}
.output-tft .input-field-btn textarea {
    width: 90%;
  min-height: 60px;
    padding: 10px 40px 10px 20px;
}

.output-tft .input-field-btn button {
    width: auto;
   height: auto;
    right: 10px;
    bottom: 10px;
    padding: 6px 15px;
    display: flex;
    justify-content: space-between;
}
.output-tft .output-outer-content {
    min-height: calc(100vh - 135px);
}
.given-container .message-content-inner img,
.given-container .message-content-inner hr{
display: none;
}

.welcome-main-teaching {
    margin-left: 227px;
}
/* .output-container.output-tft .message-content-inner ul {
    margin-bottom: 0;
} */
 .multipleChoice {
   min-height: 100vh 
 }

.homme-outer-container {
    height:80vh; 
}
.homme-outer-containers,
.homme-outer-container {
    display: flex;
    justify-content: center;
    align-items: center;
}
@media screen and (max-width: 480px) {
/* logo-scsc.logomain → HomeHeader1.css */
.welcome-main-teaching {
    margin-left: 0;
}
}

/* ========== TFT Frontend page style here ===========*/
.tft-front-page {
 padding: 0 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    min-height: 100vh;
    max-width: 1330px;
    margin: 0 auto;
    width: 100%;
    box-sizing: border-box;
}
.tft-front-page h2.mb-4 {
    font-weight: 600;
    margin-bottom: 24px;
    color: #2d333a;
}
.organisaton-container {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: stretch;
    gap: 40px;
    overflow: hidden;
    width: 100%;
}
.choose-organisaton {
   padding: 10px 20px;
    width: 50%;
    border: 1px solid #cdcdcd;
     border-radius: 8px;
    display: flex;
    flex-direction: column;
    min-height: 226px;
    box-sizing: border-box;
    background: #fff;
}


.choose-organisaton-img {
    width: 100%;
    max-width: 100%;
    min-width: 0;
}

.choose-organisaton-img.organisation-imag-inne {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
    width: 100%;
    max-width: 100%;
    min-width: 0;
}

.choose-organisaton-img.organisation-imag-inne > div:first-child {
    min-width: 0;
    flex: 1 1 auto;
    max-width: 100%;
}

.wam-coming3d-wrap {
    flex-shrink: 0;
}

.wam-coming3d-text {
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    color: #adabab;
    padding: 10px 12px;
    border-radius: 5px;
    border: 1px solid #cdcdcd;
    margin: 0;
    white-space: nowrap;
}

.choose-organisaton:hover .wam-coming3d-text {
    color: #1c5499;
    border: 1px solid #1c5499;
}

.choose-organisaton img {
  max-width: min(350px, 100%);
  height: auto;
  display: block;
  width: auto;
  position: relative;
  object-fit: contain;
}
.organisation-text-info {
    min-height: 89px;
    flex: 1 1;
}
.organisation-text-info p {
    margin: 0;
    color: #2d333a;
    line-height: 1.5;
}
.choose-organisaton button {
    min-width: 130px;
    margin-top: auto;
    align-self: flex-start;
    background-color: #fff;
    color: #212529;
}
.choose-organisaton button .fa {
    font-size: 11px;
}
.choose-organisaton:hover button {
      background: rgba(44, 104, 161, 1);
      color: #fff;
}
    .choose-organisaton:hover {
    cursor: pointer;
    border:1px solid rgba(44, 104, 161, 1);
    box-shadow: 0 8px 15px rgba(0,0,0,0.2); 
    }
    .choose-organisaton-coming-soon:hover {
    cursor: default;
    }

@media screen and (max-width: 480px) {
    .choose-organisaton {
        min-height: 226px!important;
    }

    .organisation-text-info {
        min-height: auto;
        flex: 0 0 auto;
    }

    .choose-organisaton:not(.choose-organisaton-coming-soon) .choose-organisaton-img img {
        max-width: 72%;
        width: auto;
    }

    .choose-organisaton-img.organisation-imag-inne > div:first-child {
        flex: 1 1 68%;
    }

    .choose-organisaton-img.organisation-imag-inne > div:first-child img {
        max-width: 100%;
        width: 100%;
    }

    .choose-organisaton-img.organisation-imag-inne .wam-coming3d-text {
        font-size: 8px;
        padding: 5px 8px;
    }
}

    .spaceTopBottom {
    margin-top: 15px;
    margin-bottom: 16px;
    }
    .scsbc-chartboart {
    max-width:550px;
    width: 100%;
    margin: 0 auto;
    /* border:1px solid hsl(214.3 31.8% 91.4%);
    box-shadow: 0px 2px 5px 2px #e2e8f0; */
    padding:10px 20px 20px 20px;
    border-radius: 8px;
    }
    .learning-supports-full-width.scsbc-chartboart {
    max-width: 75%;
    width: 75%;
    }
    .twice-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    padding-top: 25px;
    }
    
    .twice-btn .btn {
    background-color: rgba(44, 104, 161, 1);
    color: rgba(255, 255, 255, 1);
    min-width: 115px;
    padding: 8px 15px 9px 15px;
    border-radius: 12px;
    }
    .unit-plan:hover, 
    .twice-btn .btn:hover {
    border:1px solid hsl(214.3 31.8% 91.4%);
    box-shadow: 0px 2px 5px 2px #e2e8f0;
    background: transparent;
    color:#000;
    }


    .afterchatbot .output-tft .input-field-btn textarea {
    line-height: 35px;
    }

    /* .afterchatbot .home-page-content-inner .output-tft .input-field-btn textarea {
    width: 100%;
    min-height: 60px;
    padding: 10px 20px;
    max-width: 87%;
    }

    .afterchatbot .inner-images-content {
    padding: 10px 0px 60px 0;
    }

  
    .afterchatbot .home-page-content-inner .output-tft .input-field-btn {
        width: 100%;
    }
    .afterchatbot .output-tft .input-field-btn button {
    bottom: -51px!important;
    }
    .afterchatbot .output-tft .input-field-btn {
    display: flex;
    gap: 0px;
    }
    .afterchatbot .output-tft .input-field-btn button {
    right: 0;
    } */
 
    .afterchatbot .given-container .message-inner-div{
    margin-bottom: 0;
    }
      .afterchatbot .home-page-content-inner .output-tft .input-field-btn textarea {
    width: 100%;
    max-width: 100%;
    }
    .afterchatbot .given-container .message-inner-div {
    padding: 15px 15px 30px 15px;
    }
    .afterchatbot .given-container .message-content-inner .group-image{
    width: 18px!important;
    height: 18px !important;
    position: relative;
    bottom: 33px;
    left: 25px;
    }

    @media only screen and (max-width: 480px) {
    .afterchatbot .inner-images-content {
    padding: 10px 0px 44px 0;
    }
    .afterchatbot .home-page-content-inner .output-tft .input-field-btn textarea {
    width: 95%;
    max-width: 100%;
    }
    .afterchatbot .home-page-content-inner .output-tft .input-field-btn {
        width: 100%;
    }
    .afterchatbot .output-tft .input-field-btn button {
    width: 69px;
    height: 35px;
    bottom: -45px!important;
    }
    .afterchatbot .output-tft .translate-inn{
    transform: translateY(0%)!important;
    }
    .afterchatbot .output-tft .input-field-btn {
    display: flex;
    gap: 0px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/style.css"],"names":[],"mappings":"CAAC;EACC,aAAa;AACf;CACC;GACE,aAAa;CACf;AACD;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;AACpB;AACA;;;AAGA,cAAc;AACd;AACA;IACI,gBAAgB;IAChB,UAAU;AACd;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;;IAEI,QAAQ;IACR,UAAU;IACV,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;AACA;AACA;IACI,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,uCAAuC;IACvC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,aAAa;IACb,eAAe;IACf,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,4BAA4B;IAC5B,6BAA6B;IAC7B,qBAAqB;IACrB,iBAAiB;;AAErB;AACA;IACI,kBAAkB;AACtB;;;AAGA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,sBAAsB;AAC1B;AACA;AACA,uBAAuB;EACrB,kBAAkB;IAChB,YAAY;IACZ,iBAAiB,CAAC;AACtB;IACI,iBAAiB;KAChB,gBAAgB;MACf,kBAAkB;AACxB;AACA;IACI,gBAAgB;AACpB;AACA;GACG,cAAc;IACb,eAAe;KACd,gBAAgB;KAChB,cAAc;AACnB;AACA;KACK,mBAAmB;MAClB,cAAc;OACb,WAAW;SACT,yBAAyB;UACxB,kBAAkB;UAClB,qBAAqB;AAC/B;AACA;IACI,aAAa;QACT,mBAAmB;QACnB,uBAAuB;QACvB,kBAAkB;QAClB,YAAY;QACZ,YAAY;QACZ,yBAAyB;QACzB,WAAW;QACX,gBAAgB;QAChB,kBAAkB;QAClB,iBAAiB;QACjB,aAAa;QACb,eAAe;QACf,eAAe;AACvB;AACA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;IACf,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;IACd,YAAY;AAChB;AACA;IACI,aAAa;KACZ,mBAAmB;MAClB,cAAc;AACpB;AACA;AACA,YAAY;CACX,YAAY;EACX,6BAA6B;EAC7B,cAAc;EACd,SAAS;AACX;AACA;CACC,gBAAgB;EACf,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,SAAS;EACT,yBAAyB;EACzB,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,aAAa;KACZ,WAAW;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,yEAAyE;IACzE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,SAAS;IACT,0FAA0F;AAC9F;AACA;AACA,WAAW;CACV,YAAY;EACX,oBAAoB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;;;AAIA;IACI,aAAa;MACX,uBAAuB;OACtB,gBAAgB;QACf,sBAAsB;QACtB,iBAAiB,CAAC;AAC1B;AACA,uBAAuB;EACrB,kBAAkB;IAChB,WAAW;;AAEf;;AAEA;KACK,kBAAkB;KAClB,2BAA2B;IAC5B,0BAA0B;IAC1B,aAAa;IACb,cAAc;AAClB;AACA;CACC,gBAAgB;AACjB;AACA;AACA,yBAAyB;EACvB,kBAAkB;GACjB,kBAAkB;GAClB,gBAAgB;GAChB,YAAY;GACZ,aAAa;OACT,mBAAmB;OACnB,8BAA8B;OAC9B,eAAe;OACf,yBAAyB;OACzB,mBAAmB;AAC1B;AACA;AACA,cAAc;CACb,WAAW;AACZ;;AAEA;IACI,cAAc;AAClB;AACA;IACI,cAAc;KACb,mBAAmB;MAClB,gBAAgB;OACf,YAAY;QACX,cAAc;SACb,eAAe;AACxB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;KACb,WAAW;MACV,eAAe;OACd,yBAAyB;QACxB,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,yBAAyB;QACzB,kBAAkB;QAClB,YAAY;IAChB,qBAAqB;AACzB;AACA;IACI,cAAc;KACb,mBAAmB;MAClB,gBAAgB;OACf,YAAY;QACX,cAAc;SACb,eAAe;AACxB;AACA;IACI,gBAAgB;KACf,WAAW;MACV,yBAAyB;OACxB,YAAY;QACX,eAAe;QACf,kBAAkB;SACjB,YAAY;UACX,eAAe;UACf,aAAa;cACT,mBAAmB;cACnB,uBAAuB;cACvB,kBAAkB;cAClB,WAAW;cACX,gBAAgB;cAChB,eAAe;cACf,gBAAgB;cAChB,aAAa;cACb,eAAe;AAC7B;AACA;KACK,cAAc;MACb,mBAAmB;OAClB,gBAAgB;QACf,YAAY;SACX,cAAc;UACb,eAAe;WACd,kBAAkB;WAClB,SAAS;IAChB,YAAY;IACZ,6BAA6B;IAC7B,eAAe;IACf,qBAAqB;IACrB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;KACjB,cAAc;MACb,cAAc;OACb,iBAAiB;OACjB,gBAAgB;AACvB;AACA;KACK,cAAc;KACd,qBAAqB;KACrB,eAAe;KACf,gBAAgB;AACrB;AACA;IACI,aAAa;KACZ,mBAAmB;MAClB,cAAc;AACpB;AACA;AACA,YAAY;CACX,YAAY;EACX,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;IACI,gBAAgB;KACf,cAAc;KACd,eAAe;KACf,gBAAgB;AACrB;AACA;IACI,aAAa;KACZ,WAAW;AAChB;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,sBAAsB;IACtB,YAAY;IACZ,yEAAyE;IACzE,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,UAAU;IACV,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,eAAe;IACf,SAAS;IACT,0FAA0F;AAC9F;AACA;IACI,WAAW;KACV,YAAY;MACX,oBAAoB;AAC1B;AACA;KACK,kBAAkB;MACjB,mBAAmB;OAClB,cAAc;OACd,SAAS;OACT,YAAY;AACnB;AACA;KACK,cAAc;MACb,qBAAqB;MACrB,cAAc;MACd,eAAe;MACf,gBAAgB;AACtB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;AACb;AACA;IACI,kBAAkB;AACtB,WAAW;AACX;;;;AAIA;IACI,aAAa;MACX,uBAAuB;OACtB,gBAAgB;QACf,sBAAsB;AAC9B;AACA;MACM,kBAAkB;QAChB,eAAe;QACf,iBAAiB;AACzB;AACA;IACI,eAAe;KACd,gBAAgB;MACf,kBAAkB;MAClB,SAAS;AACf;AACA;IACI,kBAAkB;KACjB,cAAc;MACb,eAAe;MACf,gBAAgB;AACtB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,cAAc;KACb,WAAW;MACV,eAAe;OACd,yBAAyB;QACxB,kBAAkB;IACtB;IACA;QACI,cAAc;QACd,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,WAAW;SACV,yBAAyB;UACxB,YAAY;WACX,eAAe;WACf,kBAAkB;YACjB,YAAY;aACX,eAAe;aACf,aAAa;iBACT,mBAAmB;iBACnB,uBAAuB;iBACvB,kBAAkB;iBAClB,WAAW;iBACX,gBAAgB;iBAChB,eAAe;iBACf,gBAAgB;iBAChB,aAAa;iBACb,eAAe;IAC5B;IACA;QACI,kBAAkB;QAClB,WAAW;QACX,gBAAgB;;IAEpB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;IACA;QACI,cAAc;SACb,mBAAmB;UAClB,gBAAgB;WACf,YAAY;YACX,cAAc;aACb,eAAe;cACd,kBAAkB;AAChC,eAAe;AACf,cAAc;AACd,gBAAgB;IACZ;IACA;QACI,kBAAkB;SACjB,mBAAmB;UAClB,aAAa;WACZ,gBAAgB;IACvB;IACA;AACJ,cAAc;CACb,qBAAqB;;IAElB;;;;IAIA;AACJ,aAAa;CACZ,sBAAsB;GACpB,gBAAgB;IACf,sBAAsB;IACtB;;IAEA;UACM,kBAAkB;UAClB,eAAe;UACf,iBAAiB;IACvB;IACA;QACI,kBAAkB;IACtB,eAAe;KACd,gBAAgB;MACf,mBAAmB;IACrB;IACA;AACJ,WAAW;CACV,aAAa;EACZ,mBAAmB;GAClB,sBAAsB;IACrB,kBAAkB;IAClB;;IAEA;QACI,eAAe;SACd,cAAc;UACb,kBAAkB;IACxB;IACA;AACJ,cAAc;CACb,0BAA0B;IACvB;;IAEA;QACI,gBAAgB;QAChB,WAAW;SACV,yBAAyB;UACxB,YAAY;WACX,eAAe;WACf,kBAAkB;YACjB,YAAY;aACX,eAAe;aACf,aAAa;iBACT,mBAAmB;iBACnB,uBAAuB;iBACvB,kBAAkB;iBAClB,WAAW;iBACX,gBAAgB;iBAChB,eAAe;iBACf,gBAAgB;iBAChB,aAAa;iBACb,eAAe;IAC5B;;;;;;;AAOJ;IACI,aAAa;AACjB;AACA;IACI,WAAW;AACf;AACA;AACA,YAAY;AACZ,qBAAqB;AACrB;;;;;;;;;;;;;;;;;;;;;AAqBA;AACA,WAAW;IACP,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;YAEY,sDAAsD;YACtD;gBACI,YAAY;gBACZ,YAAY;gBACZ,sCAAsC;gBACtC,kCAAkC;gBAClC,eAAe;gBACf,gBAAgB;gBAChB,kBAAkB;gBAClB,6BAA6B;gBAC7B,YAAY;YAChB;YACA;gBACI,yBAAyB;gBACzB,WAAW;gBACX,aAAa;gBACb,kBAAkB;gBAClB,wCAAwC;gBACxC,mDAAmD;gBACnD,mBAAmB;;;YAGvB;;YAEA;gBACI,WAAW;gBACX,YAAY;gBACZ,mBAAmB;YACvB;YACA;gBACI,YAAY;gBACZ,kCAAkC;gBAClC,eAAe;gBACf,gBAAgB;gBAChB,6BAA6B;gBAC7B,YAAY;gBACZ,YAAY;;;YAGhB;YACA;gBACI,kCAAkC;gBAClC,eAAe;gBACf,gBAAgB;gBAChB,kBAAkB;YACtB;YACA;gBACI,aAAa;YACjB;YACA;gBACI,gBAAgB;gBAChB,kCAAkC;gBAClC,eAAe;gBACf,gBAAgB;gBAChB,6BAA6B;YACjC;;YAEA;gBACI,kBAAkB;YACtB;YACA;gBACI,kBAAkB;YACtB;YACA;gBACI,kBAAkB;gBAClB,kBAAkB;YACtB;YACA;AACZ,YAAY;AACZ,YAAY;AACZ,iBAAiB;AACjB,wCAAwC;AACxC,mDAAmD;AACnD,mBAAmB;AACnB,kCAAkC;AAClC,eAAe;AACf,gBAAgB;AAChB,0BAA0B;AAC1B,eAAe;AACf;AACA;IACI,aAAa;AACjB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;AACA;;IAEI,cAAc;IACd,gBAAgB;AACpB;AACA,mCAAmC;AACnC;;IAEI,yBAAyB;AAC7B;;;;;;;;;;AAUA;IACI;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,mBAAmB;IACvB;IACA;QACI,WAAW;IACf;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,YAAY;QACZ,YAAY;IAChB;AACJ;;;;AAIA;IACI;QACI,kBAAkB;QAClB,aAAa;QACb,YAAY;IAChB;AACJ;IACI,mBAAmB;;AAEvB;AACA;IACI,kBAAkB;AACtB;;AAEA;;;;;EAKE;IACE,WAAW;IACX,sCAAsC;IACtC,0CAA0C;IAC1C,0CAA0C;IAC1C,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,8EAA8E;AAClF;;AAEA,iCAAiC;AACjC;IACI,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,MAAM;IACN,iCAAiC;AACrC;;AAEA;;;;GAIG;AACH;;;GAGG;AACH;;;;GAIG;AACH;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;AACvB;AACA,2CAA2C;AAC3C;IACI,wBAAwB;IACxB,sCAAsC;IACtC,WAAW;AACf;;;AAGA;IACI,OAAO;AACX;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;;;IAGE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;;EAGA;IACE,eAAe;IACf,WAAW;IACX,YAAY;EACd;EACA;IACE,YAAY;IACZ,iCAAiC;EACnC;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,iCAAiC;IACjC,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;;;;;;EAOA,uEAAuE;AACzE;AACA,aAAa;AACb,8BAA8B;AAC9B,mBAAmB;AACnB;AACA;IACI,kCAAkC;IAClC,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;IACI,kCAAkC;IAClC,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;QACX,uBAAuB;IAC3B,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,YAAY;IACZ,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0CAA0C;IAC1C,mBAAmB;IACnB,kBAAkB;IAClB,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,eAAe;IACf,UAAU;IACV,YAAY;IACZ,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,UAAU;IACV,WAAW;IACX,gBAAgB;EAClB;EACA;EACA,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV;AACF;IACI,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,kCAAkC;IAClC,6BAA6B;IAC7B,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,kBAAkB;EACpB;EACA;IACE,8CAA8C;EAChD;EACA,oDAAoD;;AAEtD;IACI,kBAAkB;AACtB;AACA;IACI,sBAAsB;AAC1B,kCAAkC;AAClC,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB;AACA;;IAEI,wCAAwC;IACxC,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,yDAAyD;AAC7D;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,oDAAoD;IACpD,6BAA6B;AACjC;AACA;KACK,4BAA4B;AACjC;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,uCAAuC;IACvC,WAAW;AACf;AACA,uCAAuC;AACvC;;IAEI,kCAAkC;IAClC,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,eAAe;IACf,WAAW;IACX,wCAAwC;IACxC,WAAW;IACX,wCAAwC;IACxC,mBAAmB;IACnB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;AACA;AACA,iBAAiB;AACjB,eAAe;AACf;AACA;IACI,aAAa;IACb,WAAW;GACZ,gBAAgB;AACnB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;;IAE7B,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB,eAAe;;AAEf;AACA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,6BAA6B;IAC7B,SAAO;MACL,YAAY;QACV,gBAAgB;MAClB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;MAClB,eAAe;MACf,aAAa;MACb,gBAAgB;AACtB;;AAEA;AACA,aAAa;AACb;AACA;AACA,aAAa;AACb,YAAY;AACZ;AACA;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,QAAQ;AACZ;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,SAAS;AACb;AACA;IACI,sDAAsD;EACxD;EACA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;AACF;IACI,kBAAkB;AACtB;;;;;;;;;;;AAWA,yCAAyC;;AAEzC;AACA;QACQ,WAAW;IACf;IACA;IACA,WAAW;IACX;IACA;QACI,0BAA0B;IAC9B;IACA,0DAA0D;IAC1D;QACI,WAAW;IACf;IACA;QACI,0BAA0B;IAC9B;IACA;QACI,4BAA4B;IAChC;IACA;QACI,aAAa;IACjB;IACA,2DAA2D;AAC/D;IACI,eAAe;IACf,SAAS;AACb;AACA;IACI,YAAY;AAChB;AACA;;;;AAIA;;IAEI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,uCAAuC;AAC3C;AACA;;IAEI,YAAY;IACZ,YAAY;;AAEhB;AACA;AACA,wCAAwC;AACxC;AACA;IACI,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,wCAAwC;IACxC,kBAAkB;IAClB,6BAA6B;IAC7B,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;KACd,6BAA6B;KAC7B,kCAAkC;KAClC,gBAAgB;KAChB,eAAe;KACf,iBAAiB;AACtB;AACA;IACI,4BAA4B;IAC5B,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;AAErB;AACA;IACI,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;QACf,eAAe;AACvB;AACA;IACI,wCAAwC;IACxC,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,iCAAiC;IACjC,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA,wEAAwE;AACxE;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;AACxB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;AACA,WAAW;AACX,YAAY;AACZ;AACA;;;IAGI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;AACA;AACA,kBAAkB;AAClB,kCAAkC;AAClC,gBAAgB;AAChB,eAAe;AACf,iBAAiB;AACjB,mBAAmB;AACnB;AACA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,SAAS;AACb;AACA;AACA,wBAAwB;AACxB,4CAA4C;AAC5C,0BAA0B;AAC1B,yBAAyB;AACzB,2BAA2B;AAC3B;AACA;IACI,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;AACA;;IAEI,YAAY;IACZ,kBAAkB;AACtB,yBAAyB;AACzB,kBAAkB;AAClB,mBAAmB;AACnB,6BAA6B;AAC7B,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;AACA;IACI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;AACpB;AACA;IACI,cAAc;AAClB,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,uBAAuB;AACvB;AACA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;AAC/B;AACA;AACA,mBAAmB;AACnB,mBAAmB;AACnB,4BAA4B;AAC5B;AACA;IACI,kCAAkC;IAClC,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;;AAEb;AACA;IACI,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;AACjB;AACA;;;;;GAKG;AACH;IACI,aAAa;IACb,iBAAiB;IACjB,oBAAoB;AACxB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;AACvB,yBAAyB;AACzB,6BAA6B;AAC7B,+CAA+C;AAC/C,SAAO;MACD,YAAY;QACV,gBAAgB;MAClB,iBAAiB;MACjB,sBAAsB;MACtB,kBAAkB;MAClB,eAAe;MACf,aAAa;MACb,gBAAgB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;CACC,YAAY;IACT,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,QAAQ;IACR,uBAAuB;AAC3B;AACA;IACI,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;;AAElB,sBAAsB;AACtB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,iBAAiB;AACjB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB,YAAY;AACZ,mBAAmB;AACnB,yBAAyB;AACzB,cAAc;AACd,oBAAoB;AACpB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,gBAAgB;AAChB,sBAAsB;AACtB;;AAEA;AACA,iBAAiB;AACjB,kBAAkB;AAClB;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,SAAS;AACb;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,iBAAiB;AACrB;AACA;IACI,mCAAmC;IACnC,sBAAsB;AAC1B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;;EAEnB,8BAA8B;EAC9B,qBAAqB,qBAAqB,gCAAgC;EAC1E,iCAAiC,SAAS,kBAAkB;AAC9D;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,6BAA6B,EAAE,sCAAsC;EACrE,4BAA4B;AAC9B;;;;AAIA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;;;;;;;AAQA;MACM,SAAO;MACP,gBAAgB;MAChB,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB,SAAS;IACX;;;;IAIA;MACE,aAAa;MACb,aAAa;MACb,0BAA0B;MAC1B,sBAAsB;IACxB;;;;;;AAMJ;IACI;IACA,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,6BAA6B;AACjC;;AAEA,yCAAyC;IACrC;QACI,eAAe;AACvB;AACA;IACI,QAAQ;AACZ;AACA;AACA;AACA;QACQ,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;IACA,WAAW;IACX;;;AAGJ;IACI,aAAa;AACjB;AACA;IACI,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;AAChB;AACA;IACI,WAAW;AACf;AACA;IACI,sBAAsB;AAC1B;AACA;AACA;;IAEI;QACI,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,YAAY;IAChB;IACA;IACA,WAAW;IACX;AACJ;IACI,aAAa;AACjB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;AAChB;AACA;IACI,+BAA+B;AACnC;AACA;IACI,uBAAuB;IACvB,kCAAkC;IAClC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,WAAW;IACX,eAAe;AACnB;AACA;CACC,WAAW;AACZ;AACA;IACI,6BAA6B;AACjC;AACA,yCAAyC;AACzC;;;;AAIA,6CAA6C;;AAE7C,mDAAmD;AACnD;IACI,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;KAChB,kCAAkC;;AAEvC;;AAEA;IACI,2BAA2B;OACxB,SAAY;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;;;AAIA;KACK,kCAAkC;IACnC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,qBAAqB;IACrB,qCAAqC;;AAEzC;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,UAAU;;AAEd;CACC;IACG;AACJ;AACA;GACG,iBAAiB;AACpB;AACA;IACI,WAAW;IACX,oBAAoB;IACpB,oBAAoB;AACxB;AACA;IACI,UAAU;KACT,eAAe;IAChB,gBAAgB;AACpB;AACA;KACK,mBAAmB;IACpB,mBAAmB;IACnB,4BAA4B;IAC5B,mBAAmB;IACnB,yBAAyB;GAC1B,cAAc;OACV,WAAW;AAClB;;AAEA;IACI,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;IACjB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,qCAAqC;AACzC;AACA;IACI,UAAU;EACZ,gBAAgB;IACd,4BAA4B;AAChC;;AAEA;IACI,WAAW;GACZ,YAAY;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,8BAA8B;AAClC;AACA;IACI,+BAA+B;AACnC;AACA;;AAEA,aAAa;AACb;;AAEA;IACI,kBAAkB;AACtB;AACA;;GAEG;CACF;GACE;CACF;;AAED;IACI,WAAW;AACf;AACA;;IAEI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;AACA,yCAAyC;AACzC;IACI,cAAc;AAClB;AACA;;AAEA,uDAAuD;AACvD;CACC,eAAe;IACZ,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;IACd,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,oBAAoB;IACpB,SAAS;IACT,gBAAgB;IAChB,WAAW;AACf;AACA;GACG,kBAAkB;IACjB,UAAU;IACV,yBAAyB;KACxB,kBAAkB;IACnB,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;;AAGA;IACI,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,YAAY;EACZ,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;AACA;IACI,gBAAgB;IAChB,SAAO;AACX;AACA;IACI,SAAS;IACT,cAAc;IACd,gBAAgB;AACpB;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;MACM,iCAAiC;MACjC,WAAW;AACjB;IACI;IACA,eAAe;IACf,sCAAsC;IACtC,sCAAsC;IACtC;IACA;IACA,eAAe;IACf;;AAEJ;IACI;QACI,2BAA2B;IAC/B;;IAEA;QACI,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,WAAW;IACf;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,cAAc;QACd,gBAAgB;IACpB;AACJ;;IAEI;IACA,gBAAgB;IAChB,mBAAmB;IACnB;IACA;IACA,eAAe;IACf,WAAW;IACX,cAAc;IACd;0CACsC;IACtC,2BAA2B;IAC3B,kBAAkB;IAClB;IACA;IACA,cAAc;IACd,UAAU;IACV;IACA;IACA,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB;;IAEA;IACA,uCAAuC;IACvC,6BAA6B;IAC7B,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;IACnB;IACA;;IAEA,uCAAuC;IACvC,mCAAmC;IACnC,uBAAuB;IACvB,UAAU;IACV;;;IAGA;IACA,iBAAiB;IACjB;;IAEA;;;;;;;;;;;;;;;;;;;;;;;;OAwBG;;IAEH;IACA,gBAAgB;IAChB;MACE;IACF,WAAW;IACX,eAAe;IACf;IACA;IACA,4BAA4B;IAC5B;IACA;IACA,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV;;IAEA;IACA;IACA,wBAAwB;IACxB;IACA;IACA,UAAU;IACV,eAAe;IACf;IACA;QACI,WAAW;IACf;IACA;IACA,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB;IACA;IACA,mCAAmC;IACnC;IACA;IACA,aAAa;IACb,QAAQ;IACR;AACJ","sourcesContent":[" .forget-pass-input input::-webkit-password-toggle-button { \n  display: none; \n} \n .forget-pass-input input::-ms-reveal { \n   display: none; \n } \n.check-inner{\n    padding: 14px 16px;\n    border: 1px solid #d9d9d9;\n    margin-top: 10px;\n} \n.check-inner li .check-iconn,\n.check-inner ul, \n.check-inner li{\ncolor: #0a8852;\n}\n.check-inner ul{\n    margin-bottom: 0;\n    padding: 0;\n}\n.input-container {\n    position: relative;\n    width: 100%;\n    max-width: 320px;\n}\n\n.input-container input {\n    width: 100%;\n    padding: 0px;\n    font-size: 16px;\n    border: 2px solid #ccc;\n    border-radius: 5px;\n    outline: none;\n    height: 3.25rem;\n    padding-left: 20px;\n}\n.footer-innner-reset{\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n}\n\n.input-container label {\n    display: block;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-54%);\n    font-size: 16px;\n    color: #888;\n    transition: all 0.0s ease;\n    pointer-events: none;\n    padding-left: 1.25rem;\n}\n\n.input-container input:focus + label,\n.input-container input:not(:placeholder-shown) + label {\n    top: 0px;\n    left: 1rem;\n    font-size: 14px;\n    color: #b4b4b4;\n    background: white;\n    padding: 0 5px;\n}\n.input-container input:focus{\n    border: 1px solid #10a37f;\n}\n\n\n.password-inner-page input:focus + label{\n    color: #10a37f;\n}\n\n.input-container .eye-icon{\n    position: absolute;\n    right: 0px;\n    bottom: 1px;\n    padding: 12px 16px 12px 16px;\n    cursor: pointer;\n}\n.reset-password{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height: calc(100vh -45px);\n    background-color: #fff;\n}\n.reset-password-inner{\n    background-color: white;\n    border-radius: 8px;\n    width: 320px;\n    padding-top: 10vh;\n}\n.reset-password-inner h1{\n    font-size: 32px;\n    margin: 24px 0 0;\n    color: #2d333a;\n    width: 320px;\n    text-align: center;\n    margin-bottom: 15px;\n}\n.reset-password-inner p{\n    font-size: 14px;\n    margin-bottom: 20px;\n}\n.reset-password-inner button{\ndisplay: flex\n;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    height: 52px;\n    width: 320px;\n    background-color: rgba(44, 104, 161, 1);\n    color: #fff;\n    margin: 24px 0 0;\n    border-radius: 6px;\n    padding: 4px 16px;\n    font: inherit;\n    border-width: 0;\n    cursor: pointer;\n    margin-bottom: 20px;\n}\n.reset-password-inner a{\n    border: 0;\n    padding: 2px;\n    margin: 0;\n    line-height: 18px;\n    display: inline;\n    cursor: pointer;\n    vertical-align: baseline;\n    font-size: inherit;\n    border-radius: 3px;\n    color: rgba(44, 104, 161, 1);\n    background-color: transparent;\n    text-decoration: none;\n    font-weight: bold;\n\n}\n.back-to{\n    text-align: center;\n}\n\n\n.main-singup{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-height:calc(100vh-45px) ;\n    background-color: #fff;\n}\n.signup-inner{\nbackground-color: white;\n  border-radius: 8px;\n    width: 320px;\n    padding-top: 10vh;}\n.signip-inner h2{\n    font-size: 1.5rem;\n     font-weight: 600;\n      text-align: center;\n}\n.email-inner{\n    margin-top: 1rem;\n}\n.email-inner label{\n   display: block;\n    font-size: 1rem;\n     font-weight: 500;\n     color: #b4b4b4;\n}\n.email-inner input{\n     margin-top: 0.25rem;\n      display: block;\n       width: 100%;\n         border: 1px solid #d1d5db;\n          border-radius: 4px;\n          padding-left: 1.25rem;\n}\n.email-inner button{\n    display: flex;\n        align-items: center;\n        justify-content: center;\n        position: relative;\n        height: 52px;\n        width: 320px;\n        background-color: #10a37f;\n        color: #fff;\n        margin: 24px 0 0;\n        border-radius: 6px;\n        padding: 4px 16px;\n        font: inherit;\n        border-width: 0;\n        cursor: pointer;\n}\n.login-account{\n    text-align: center;\n    margin-top: 16px;\n    margin-bottom: 0;\n    font-size: 14px;\n    color: #000;\n}\n.login-account a{ \n    font-weight: 400;\n    text-decoration: inherit;\n    color: #10a37f;\n    padding: 4px;\n}\n.or-inner{\n    display: flex;\n     align-items: center;\n      margin: 1rem 0;\n}\n.or-inner hr{\nflex-grow: 1;\n border: none;\n  border-top: 1px solid #c2c8d0;\n  flex: 1 0 auto;\n  margin: 0;\n}\n.or-inner span{\n margin: 0 0.5rem;\n  color: #000;\n  text-align: center;\n  flex: .2 0 auto;\n  margin: 0;\n  text-transform: uppercase;\n  font-size: 12px;\n  font-weight: 400;\n}\n.continue-inner-page{\n    display: grid;\n     gap: 0.5rem;\n}\n.continue-inner-page button{\n    position: relative;\n    width: 320px;\n    border: 1px solid #c2c8d0;\n    border-radius: 6px;\n    font-size: 16px;\n    align-items: center;\n    background-color: #fff;\n    height: 52px;\n    transition: box-shadow .15 ease-in-out, background-color .15s ease-in-out;\n    cursor: pointer;\n    color: #2d333a;\n    margin-bottom: 8px;\n    display: flex;\n    outline: 0;\n    padding: 0 8px 0 18px;\n    cursor: pointer;\n    color: #2d333a;\n    font-size: 16px;\n    gap: 10px;\n    font-family: OpenAI Sans, SF Pro, -apple-system, BlinkMacSystemFont, Helvetica, sans-serif;\n}\n.continue-inner-page button img{\nwidth: 35px;\n height: 35px;\n  margin-right: 0.5rem;\n}\n.signup-inner h2{\n    font-size: 32px;\n    margin: 24px 0 0;\n    color: #2d333a;\n    width: 320px;\n    text-align: center;\n}\n\n\n\n.password-inner-main{\n    display: flex;\n      justify-content: center;\n       min-height: 95vh;\n        background-color: #fff;\n        padding-top: 15vh;}\n.password-inner-page{\nbackground-color: white;\n  border-radius :8px;\n    width:320px;\n\n}\n\n.login-password{\n     text-align: center;\n     font-weight: 500 !important;\n    font-size: 32px !important;\n    margin-top: 0;\n    color: #2d333a;\n}\n.password-main-div{\n margin-top: 1rem;\n}\n.email-edit{\nborder: 1px solid #d1d5db;\n  border-radius: 4px;\n   margin-top: 0.5rem;\n   min-height: 52px;\n   height: auto;\n   display: flex;\n       align-items: center;\n       justify-content: space-between;\n       padding: 0 16px;\n       background-color: #f1f2f3;\n       margin-bottom: 12px;\n}\n.email-edit span{\ncolor: #2d333a;\n float: left;\n}\n\n.email-edit .edit-color{\n    color: #10a37f;\n}\n.password-align{\n    display: block;\n     margin: 1rem auto 0;\n      background: none;\n       border: none;\n        color: #10b981;\n         cursor: pointer;\n}\n.password-main-div .password-align{\n    text-align: left;\n    font-weight: normal;\n}\n\n.password-main-div input{\n    display: block;\n     width: 100%;\n      padding: 0.5rem;\n       border: 1px solid #d1d5db;\n        border-radius: 4px;\n        width: 100%;\n        padding: 0;\n        border: 1px solid #d1d5db;\n        border-radius: 4px;\n        height: 52px;\n    padding-left: 1.25rem;\n}\n.password-main-div .link-inner{\n    display: block;\n     margin: 1rem auto 0;\n      background: none;\n       border: none;\n        color: #10b981;\n         cursor: pointer;\n}\n.password-main-div button{\n    margin-top: 24px;\n     width: 100%;\n      background-color: #10a37f;\n       color: white;\n        padding: 0.5rem;\n        border-radius: 4px;\n         border: none;\n          cursor: pointer;\n          display: flex;\n              align-items: center;\n              justify-content: center;\n              position: relative;\n              width: 100%;\n              min-height: 52px;\n              font-size: 16px;\n              font-weight: 400;\n              outline: none;\n              cursor: pointer;\n}\n.password-main-div a{\n     display: block;\n      margin: 1rem auto 0;\n       background: none;\n        border: none;\n         color: #10a37f;\n          cursor: pointer;\n           text-align: center;\n           border: 0;\n    padding: 2px;\n    background-color: transparent;\n    cursor: pointer;\n    text-decoration: none;\n    font-size: 14px;\n    font-weight: 700;\n}\n.account-login{\n    text-align: center;\n     font-size:14px;\n      color: #2d333a;\n       margin-top : 16px;\n       font-weight: 400;\n}\n.account-login a{\n     color: #10a37f;\n     text-decoration: none;\n     font-size: 14px;\n     font-weight: 400;\n}\n.or-hr-page{\n    display: flex;\n     align-items: center;\n      margin: 24px 0;\n}\n.or-hr-page hr{\nflex-grow: 1;\n border: none;\n  border-top: 1px solid #c2c8d0;\n  font-size: 12px;\n  font-weight: 500;\n}\n.or-hr-page span{\n    margin: 0 0.5rem;\n     color: #2d333a;\n     font-size: 12px;\n     font-weight: 500;\n}\n.google-inner-part{\n    display: grid;\n     gap: 0.5rem;\n}\n.google-inner-part button{\n    position: relative;\n    width: 320px;\n    border: 1px solid #c2c8d0;\n    border-radius: 6px;\n    font-size: 16px;\n    align-items: center;\n    background-color: #fff;\n    height: 52px;\n    transition: box-shadow .15 ease-in-out, background-color .15s ease-in-out;\n    cursor: pointer;\n    color: #2d333a;\n    margin-bottom: 8px;\n    display: flex;\n    outline: 0;\n    padding: 0 8px 0 18px;\n    cursor: pointer;\n    color: #2d333a;\n    font-size: 16px;\n    gap: 10px;\n    font-family: OpenAI Sans, SF Pro, -apple-system, BlinkMacSystemFont, Helvetica, sans-serif;\n}\n.google-inner-part button img{\n    width: 20px;\n     height: 20px;\n      margin-right: 0.5rem;\n}\n.term-part{\n     text-align: center;\n      font-size: 0.875rem;\n       color: #6b7280;\n       margin: 0;\n       height: 45px;\n}\n.term-part a{\n     color: #10b981;\n      text-decoration: none;\n      margin: 0 10px;\n      font-size: 14px;\n      font-weight: 500;\n}\n.footer-innner{\n    position: absolute;\n    width: 100%;\n    bottom: 0;\n}\n.footer-innners {\n    position: absolute;\nwidth: 100%;\n}\n\n\n\n.verifaction-inner-part{\n    display: flex;\n      justify-content: center;\n       min-height: 85vh;\n        background-color: #fff;\n}\n.verification-content{\n      border-radius: 8px;\n        width: 21.25rem;\n        padding-top: 15vh;\n}\n.verification-h2{\n    font-size: 2rem;\n     font-weight: 500;\n      text-align: center;\n      margin: 0;\n}\n.verifaication-para{\n    text-align: center;\n     color: #4b5563;\n      font-size: 1rem;\n      font-weight: 400;\n}\n.verifaction-inner-input{\n    margin-top: 1rem;\n}\n.verifaction-inner-input input{\n    display: block;\n     width: 100%;\n      padding: 0.5rem;\n       border: 1px solid #d1d5db;\n        border-radius: 4px;\n    }\n    .verifaction-inner-input input:focus + label{\n        color: #10a37f;\n        font-weight: 500;\n    }\n    \n    .continue-btn{\n        margin-top: 24px;\n        width: 100%;\n         background-color: #10a37f;\n          color: white;\n           padding: 0.5rem;\n           border-radius: 4px;\n            border: none;\n             cursor: pointer;\n             display: flex;\n                 align-items: center;\n                 justify-content: center;\n                 position: relative;\n                 width: 100%;\n                 min-height: 52px;\n                 font-size: 16px;\n                 font-weight: 400;\n                 outline: none;\n                 cursor: pointer;\n    }\n    .verifaction-inner-input .input-containers {\n        position: relative;\n        width: 100%;\n        max-width: 20rem;\n        \n    }\n\n    .password-inner-page input:focus + label{\n        color: #10a37f;\n    }\n    \n    .verifaction-inner-input .input-containers input{\n        padding: 0;\n        padding-left: 20px;\n    }\n    .resend-btn{\n        display: block;\n         margin: 25px auto 0;\n          background: none;\n           border: none;\n            color: #10b981;\n             cursor: pointer;\n              text-align: center;\nfont-size: 1rem;\ncolor: #0d0d0d;\nfont-weight: 400;\n    }\n    .terms-inner{\n        text-align: center;\n         font-size: 0.875rem;\n          color:#6b7280;\n           margin-top: 3rem;\n    }\n    .terms-inner a{\ncolor: #10b981;\n text-decoration: none;\n\n    }\n\n\n\n    .about-inner-page{\ndisplay: flex;\n justify-content:center;\n   min-height: 85vh;\n    background-color: #fff;\n    }\n\n    .about-inner-content{\n          border-radius: 8px;\n          width: 21.25rem;\n          padding-top: 15vh;\n    }\n    .about-inner-content h2{\n        text-align: center;\n    font-size: 30px;\n     font-weight: 600;\n      margin-bottom: 20px;\n    }\n    .about-inner-form input{\nwidth: 100%;\n padding: 10px;\n  margin-bottom: 16px;\n   border: 1px solid #ccc;\n    border-radius: 4px;\n    }\n\n    .about-inner-form p{\n        font-size: 12px;\n         color: #6b7280;\n          margin-bottom:16px;\n    }\n    .about-inner-form p a{\ncolor: #2563eb;\n text-decoration: underline;\n    }\n\n    .about-inner-form button{\n        margin-top: 24px;\n        width: 100%;\n         background-color: #10a37f;\n          color: white;\n           padding: 0.5rem;\n           border-radius: 4px;\n            border: none;\n             cursor: pointer;\n             display: flex;\n                 align-items: center;\n                 justify-content: center;\n                 position: relative;\n                 width: 100%;\n                 min-height: 52px;\n                 font-size: 16px;\n                 font-weight: 400;\n                 outline: none;\n                 cursor: pointer;\n    }\n\n\n\n\n\n\n.sidebar-content-other{\n    display: flex;\n}\n.home-page-content-inner{\n    width: 100%;\n}\n.sidebar-content-inner{\nwidth: 277px;\nborder: 1px solid red;\n}\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.first-change-color{\nwidth: 40px;\n    height: 40px;\n    text-align: center;\n    background: #0e5f99;\n    border-radius: 50px;\n    line-height: 38px;\n    color: #fff;\n    font-size: 18px;\n    font-weight: 600;\n    margin-left: 10px;\n}\n\n            /* home-icos-btn, home-inner-icons → HomeHeader1.css */\n            .login-inner-page button{\n                width: 113px;\n                height: 43px;\n                background-color: rgba(2, 137, 214, 1);\n                font-family: 'Figtree', sans-serif;\n                font-size: 13px;\n                font-weight: 700;\n                text-align: center;\n                color: rgba(255, 255, 255, 1);\n                border: none;\n            }\n            .grade-inner-page{\n                border: 1px solid #d1d5db;\n                width: 100%;\n                height: 158px;\n                padding: 10px 15px;\n                background-color: rgba(252, 252, 252, 1);\n                box-shadow: 0.5px 0.5px 4px 0px rgba(0, 0, 0, 0.25);\n                border-radius: 15px;\n            \n\n            }\n\n            .pngtree{\n                width: 35px;\n                height: 35px;\n                margin-bottom: 15px;\n            }\n            .select-page-inner{\n                border: none;\n                font-family: 'Figtree', sans-serif;\n                font-size: 16px;\n                font-weight: 500;\n                color: rgba(113, 113, 113, 1);\n                width: 149px;\n                height: 36px;\n                \n                \n            }\n            .select-page-inner option{\n                font-family: 'Figtree', sans-serif;\n                font-size: 13px;\n                font-weight: 500;\n                padding-left: 10px;\n            }\n            .select-page-inner:focus-visible{\n                outline: none;\n            }\n            .grade-select{\n                margin-top: 15px;\n                font-family: 'Figtree', sans-serif;\n                font-size: 14px;\n                font-weight: 500;\n                color: rgba(113, 113, 113, 1);\n            }\n\n            .help-with-inner{\n                text-align: center;\n            }\n            .content-inner-page{\n                padding-top: 150px;\n            }\n            .input-box-inner{\n                text-align: center;\n                padding-top:130px ;\n            }\n            .input-box-inner input{\nwidth: 717px;\nheight: 65px;\npadding: 0px 20px;\nbackground-color: rgba(252, 252, 252, 1);\nbox-shadow: 0.5px 0.5px 4px 0px rgba(0, 0, 0, 0.25);\nborder-radius: 15px; \nfont-family: 'Figtree', sans-serif;\nfont-size: 15px;\nfont-weight: 500;\ncolor: rgba(79, 79, 79, 1);\nborder: #d1d5db;\n}\n.input-box-inner input:focus-visible{\n    outline: none;\n}\n\n.help-with-inner h4{\n    font-family: 'Figtree', sans-serif;\n    font-size: 19px;\n    font-weight: 500;\n    color: rgba(113, 113, 113, 1);\n}\n\n.help-with-inner h2{\n    font-family: 'Figtree', sans-serif;\n    font-size: 33px;\n    font-weight: 700;\n    color:rgba(46, 46, 46, 1);\n    margin-bottom: 30px;\n}\n\n.input-box-inner button{\n    width: 97px;\n    height: 38px;\n    background-color: rgba(2, 137, 214, 1);\n    border-radius: 12px;\n    border: none;\n    font-family: 'Figtree', sans-serif;\n    font-size: 15px;\n    font-weight: 600;\n    color: rgba(255, 255, 255, 1);\n    position: relative;\n    right: 120px;\n    bottom: 1px;\n}\n.input-box-inner button img{\n    width: 26px;\n    height: 26px;\n    margin-top: -2px;\n}\n\n.change-pass-para{\n    text-align: center;\n}\n.new-password-inner{\n    margin-bottom: 12px;\n}\ndiv.new-password-inner input{\n    border: 1px solid #686868;\n}\ndiv.reenter-pass input:focus + label,\ndiv.new-password-inner  input:focus + label{\n    color: #10a37f;\n    font-weight: 500;\n}\n/* header-inner → HomeHeader1.css */\n.home-page-content-inner .shrink,\n.header-inner .shrink{\n    width: calc(100% - 277px);\n}\n\n\n\n\n\n\n\n\n\n@media only screen and (max-width: 480px) {\n    .content-inner-page {\n        padding-top: 50px;\n    }\n    .help-with-inner h2 {\n        font-size: 28px;\n    }\n    .grade-inner-page {\n        margin-bottom: 15px;\n    }\n    .input-box-inner input {\n        width: 100%;\n    }\n    .input-box-inner {\n        padding-top: 50px;\n    }\n    .input-box-inner button {\n        position: relative;\n        right: -93px;\n        bottom: 51px;\n    }\n}\n\n\n\n@media only screen and (max-width: 991px) {\n    .input-box-inner button {\n        position: relative;\n        right: -292px;\n        bottom: 50px;\n    }\n.grade-inner-page {\n    margin-bottom: 15px;\n\n}\n.content-inner-page {\n    padding-top: 100px;\n}\n\n}\n\n\n\n\n  .header {\n    width: 100%;\n    height: var(--app-header-height, 85px);\n    min-height: var(--app-header-height, 85px);\n    max-height: var(--app-header-height, 85px);\n    background: #fff;\n    color: #000;\n    display: flex;\n    align-items: center;\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    z-index: 1000;\n    box-sizing: border-box;\n    overflow: visible;\n    transition: transform 0.3s ease-in-out, margin-left 0.3s ease, width 0.3s ease;\n}\n\n/* .menu-icon → HomeHeader1.css */\n.sidebar {\n    width: 277px;\n    height: 100vh;\n    background: #fff;\n    color: white;\n    position: fixed;\n    left: -277px;\n    top: 0;\n    transition: left 0.3s ease-in-out;\n}\n\n/* .sidebar ul {\n    list-style: none;\n    padding: 0;\n    padding-top: 14px;\n} */\n/* .sidebar ul li:hover{\n    background-color: #ececec;\n    border-radius: 7px;\n} */\n/* .sidebar ul li {\n    padding: 5px 10px 10px 8px;\n    cursor: pointer;\n    color: #000;\n} */\n.chat-box-text{\n    display: inline-block;\n    padding: 7px 14px;\n    border-radius: 50px;\n    background: #ececec;\n}\n/* header-inner .shrink → HomeHeader1.css */\n.content {\n    /* padding: 80px 20px; */\n    transition: transform 0.3s ease-in-out;\n    width: 100%;\n}\n\n\n.sidebar.open {\n    left: 0;\n}\n\n.content.shrink {\n    transform: translateX(277px);\n}\n\n.header.shrink {\n    transform: translateX(277px);\n}\n.sidebar-content-other {\n    display: flex;\n    transition: all 0.3s ease;\n    overflow: visible;\n  }\n\n  .home-page-content-inner > .content,\n  .home-page-content-inner > .home-inner-page,\n  .home-page-content-inner #content.content {\n    overflow-x: hidden;\n  }\n  \n  .sidebar {\n    width: 80px;\n    transition: width 0.3s ease;\n    overflow: hidden;\n  }\n  \n  .sidebar.open {\n    width: 277px;\n    padding-top: 32px;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n  \n \n  .sidebar  .menu-icon{\n    margin-top: 9px;\n    width: 26px;\n    height: 26px;\n  }\n  .home-page-content-inner {\n    flex-grow: 1;\n    transition: margin-left 0.3s ease;\n  }\n  \n  .sidebar-open .home-page-content-inner {\n    margin-left: 277px;\n  }\n  \n  .content {\n    width: 100%;\n    transition: margin-left 0.3s ease;\n    /* height: 100vh; */\n  }\n  \n  .sidebar-open .content {\n    margin-left: 0;\n  }\n\n\n\n\n\n\n  /* ..........................sidebar new css......................... */\n.sidebar-inner-image{\ndisplay: flex;\njustify-content: space-between;\nmargin-bottom: 25px;\n}\n.collapsible{\n    font-family: 'Figtree', sans-serif;\n    color:rgba(44, 104, 161, 1);\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 29px;\n    margin-bottom: 0;\n    margin-left: 10px;\n  }\n.sidebar-inner-image h2{\n    font-family: 'Figtree', sans-serif;\n    color: rgba(0, 0, 0, 1);\n    font-weight: 700;\n    font-size: 17px;\n    line-height: 29px;\n    margin-bottom: 0;\n    margin-top: 8px;\n        text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n.books-colla img{\n    width: 19.11px;\n    height: 20px;\n    margin-top: 5px;\n}\n.books-colla{\n    display: flex;\n    margin-top: 25px;\n    margin-bottom: 10px;\n    cursor: pointer;\n  }\n\n  .sidebar-inner-layout input{\n    width: 100%;\n    height: 42px;\n    border: 1.5px solid rgba(223, 223, 223, 1);\n    border-radius: 12px;\n    padding-left: 40px;\n    font-family: 'Figtree', sans-serif;\n    color: rgba(122, 122, 122, 1);\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 29px;\n  }\n  .sidebar-inner-layout .search-icon{\n    width: 14.62px;\n    height: 14.62px;\n    top: 107px;\n    bottom: auto;\n    left: 32px;\n    position: absolute;\n  }\n  \n  .Sdesign{\n    width: 8px;\n    height: 8px;\n  }\n  .Kdesign{\n    width: 8px;\n    height: 8px;\n    margin-left: 5px;\n  }\n  .SKdesign{\n  position: absolute;\n  right: 38px;\n  top: 101px;\n  }\n.full-unit h4{\n    font-family: 'Figtree', sans-serif;\n    color: rgba(113, 113, 113, 1);\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 29px;\n    margin-bottom: 0;\n}\n  .full-unit ul{\n    padding: 0;\n  }\n  .full-unit ul p{\n    padding: 0;\n    font-family: 'Figtree', sans-serif;\n    color: rgba(113, 113, 113, 1);\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 29px;\n    \n    margin-bottom: 0px;\n  }\n  .sidebar-one.open{\n    border-right: 1px solid rgba(223, 223, 223, 1);\n  }\n  /* logo-scsc, button-login-inner → HomeHeader1.css */\n\n.lorem-inner{\n    text-align: center;\n}\n.lorem-inner h2{\n    color:rgba(0, 0, 0, 1);\nfont-family: 'Figtree', sans-serif;\nfont-weight: 700;\nfont-size: 48px;\nline-height: 60px;\n}\n.unit-plan{\n\n    border: 1px solid rgba(223, 223, 223, 1);\n    height: 45px;\n    border-radius: 15px;\n    margin-top: 30px;\n    /* box-shadow: 0.3px 0.3px 4px 0px rgba(0, 0, 0, 0.25); */\n}\n.textareacustome {\n    height: 45px !important;\n}\n.green-box{\n    border: 1px solid #45D43D;\n}\n.homme-outer{\n    height: calc(100vh - var(--app-header-height, 85px));\n    padding: 100px 20px 20px 20px;\n}\n.homme-outer-new {\n     padding: 75px 20px 20px 20px;\n}\n.unit-plan{\n    display: flex;\n    justify-content: space-between;\n    padding: 8px 20px;\n    background-color: rgba(44, 104, 161, 1);\n    color: #fff;\n}\n/* home-inner-icons → HomeHeader1.css */\n.unit-plan h3{\n   \n    font-family: 'Figtree', sans-serif;\n    font-weight:400;\n    font-size: 16px;\n    line-height: 29px;\n    margin-bottom: 0;\n}\n.unit-plan img{\n    width: 30px;\n    height: 30px;\n}\n.button-next button{\n    min-width: 97px;\n    height:43px;\n    background-color: rgba(223, 223, 223, 1);\n    color: #fff;\n    border: 1px solid rgba(223, 223, 223, 1);\n    border-radius: 12px;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 600;\n    font-size: 15px;\n    margin-top: 30px;\n    padding-left: 15px;\n    padding-right: 15px;\n}\n.button-next button i{\nmargin-left: 10px;\nfont-size: 17px;\n}\n.content-inner2 {\n    height: 200px;\n    width: 100%;\n   padding: 0 205px;\n}\n.content-inner2 h4{\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 16px;\n    line-height: 29px;\n    color: rgba(113, 113, 113, 1);\n  \n    margin-bottom: 0;\n}\n.simplearrow{\n    font-size:15px;\nmargin-left:7px;\n\n}\n.content-inner2 textarea{\n    width: 100%;\n    height: 60px;\n    padding-left: 25px;\n    color:rgba(113, 113, 113, 1) ;\n    flex: 1;\n      resize: none;\n        min-height: 35px;\n      max-height: 200px;\n      border: 1px solid #ccc;\n      border-radius: 8px;\n      font-size: 15px;\n      outline: none;\n      overflow-y: auto;\n}\n\n.content-inner2 textarea:focus-visible{\noutline: none;\n}\n.content-inner2 textarea{\noutline: none;\nborder: none;\nborder-bottom: 0.8px solid rgba(223, 223, 223, 1)\n}\n\n.shrink .content-inner2 img{\n    Width: 15.27px;\n    Height: 15.27px;\n    position: absolute;\n    top: 9px;\n}\n.edit-content-answer{\n    position: relative;\n}\n.content-inner2 img{\n    Width: 15.27px;\n    Height: 15.27px;\n    position: absolute;\n    top: 24px;\n}\ndiv.input-container  input:-webkit-autofill {\n    -webkit-box-shadow: 0 0 0 1000px #fff inset !important;\n  }\n  .button-next button.back-btns{\n    background: #A7A7A7;\n    text-align: left;\n    margin-right: 12px;\n  }\n.button-next .back-btns i{\n    margin-right: 10px;\n}\n\n\n\n\n\n\n\n\n\n\n/* button-login-inner → HomeHeader1.css */\n\n@media only screen and (max-width: 480px) {\n.output-container .input-field-btn button {\n        right: 35px;\n    }\n    .output-container .input-field-btn button {\n    width: 80px;\n    }\n    .header.shrink {\n        transform: translateX(0px);\n    }\n    /* header-inner .shrink .dashboard-btn → HomeHeader1.css */\n    .home-page-content-inner .shrink, .header-inner .shrink {\n        width: 100%;\n    }\n    .content.shrink {\n        transform: translateX(0px);\n    }\n    .homme-outer {\n        padding: 20px 20px 20px 20px;\n    }\n    .sidebar.open {\n        z-index: 9999;\n    }\n    /* logo-scsc, button-login-inner button → HomeHeader1.css */\n.lorem-inner h2 {\n    font-size: 32px;\n    margin: 0;\n}\n.sidebar.open {\n    width: 250px;\n}\n}\n\n\n\n.image-inner img,\n.school-content-page img{\n    width: 327.45px;\n    position: absolute;\n}\ndiv.input-container input:focus {\n    border: 1px solid rgba(44, 104, 161, 1);\n}\n.signup-outer-pagess,\n.school-outer-pages{\n    width: 330px;\n    height: auto;\n \n}\n.or-inner hr {\nborder: 1px solid rgba(194, 200, 208, 1);\n}\n.schoo-outer{\n    height: 95vh;\n    align-items: center;\n    display: flex;\n    justify-content: center;\n}\n.school-outer-pages select{\n    width: 100%;\n    height: 55px;\n    margin-bottom: 25px ;\n    border: 1px solid rgba(194, 200, 208, 1);\n    border-radius: 6px;\n    color: rgba(45, 51, 58, 0.45);\n    padding-left: 17px;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 17px;\n    line-height: 29px;\n\n}\n.school-outer-pages .input-container{\n    position: relative;\n    width: 100%;\n    max-width: 100%;\n     color: rgba(45, 51, 58, 0.45);\n     font-family: 'Figtree', sans-serif;\n     font-weight: 500;\n     font-size: 17px;\n     line-height: 29px;\n}\np.term-part a {\n    color: rgba(44, 104, 161, 1);\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 29px;\n\n}\n.school-outer-pages button{\n    border: none;\n    background: rgba(44, 104, 161, 1);\n    color: #fff;\n    border-radius: 5px;\n    margin-top: 25px;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 29px;\n    margin-bottom: 35px;\n}\n\n.school-outer-pages h2{\n    text-align: center;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 600;\n    font-size: 33px;\n    line-height: 29px;\n    margin-bottom: 30px;\n}\n.verification-code{\n    text-align: center;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 21px;\n    color: #2D333AA6;\n    margin-bottom: 30px;\n}\ndiv.forget-passw h2{\n    margin-bottom: 15px;\n}\ndiv.forget-passw button{\n    margin-bottom: 18px;\n}\n.forget-passw .login-account{\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 29px;\n    margin-bottom: 30px;\n        cursor: pointer;\n}\n.input-container input{\n    border: 1px solid rgba(194, 200, 208, 1);\n    height: 55px;\n}\n.signup-outer-pagess .input-container {\n    position: relative;\n    max-width: 100%;\n}\n.signup-outer-pagess .continue-inner-page .continue-btn,\n.signup-outer-pagess .email-inner .continue-btn{\n    width: 100%;\n    height: 54px;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 700;\n    font-size: 13px;\n    line-height: 29px;\n    border: none;\n    background: rgba(44, 104, 161, 1);\n    color: #fff;\n    border-radius: 5px;\n    text-transform: uppercase;\n}\n.signup-outer-pagess h2{\n    text-align: center;\n    font-family: 'Figtree', sans-serif;\n    font-weight: 600;\n    font-size: 33px;\n    line-height: 29px;\n    margin-bottom: 25px;\n}\n.signup-outer-pagess .input-container input{\n    height: 55px;\n}\n/* Hide browser's password/credentials icon - sirf apna Eye icon dikhe */\n.signup-outer-pagess .input-container input[type=\"password\"]::-webkit-credentials-auto-fill-button,\n.signup-outer-pagess .input-container input[type=\"password\"]::-webkit-contacts-auto-fill-button {\n    visibility: hidden;\n    position: absolute;\n    right: 0;\n    pointer-events: none;\n}\n.signup-outer-pagess .input-container input[type=\"password\"]::-webkit-textfield-decoration-container {\n    display: none;\n}\n.signup-outer-pagess .input-container input[type=\"password\"]::-webkit-password-toggle-button {\n    display: none;\n}\n.signup-outer-pagess .input-container input[type=\"password\"]::-ms-reveal {\n    display: none;\n}\n.signup-outer-pagess .continue-inner-page button{\nwidth: 100%;\nheight: 55px;\n}\n.signup-outer-pagess .or-inner span,\n.signup-outer-pagess .login-account a,\n.signup-outer-pagess .login-account {\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 29px; \n}\n.signup-outer-pagess .login-account{\n    color:  rgba(45, 51, 58, 1);\n}\n.signup-outer-pagess .login-account a{\n    color: rgba(44, 104, 161, 1);\n}\n\n.signup-outer-pagess .continue-inner-page{\n    margin-bottom: 35px;\n}\n.signup-outer-pagess .set-your{\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 15px;\n    line-height: 29px; \n    color: rgba(45, 51, 58, 0.65);\n    text-align: center;\n    margin-bottom: 20px;\n}\n.signup-outer-pagess h3{\ntext-align: center;\nfont-family: 'Figtree', sans-serif;\nfont-weight: 600;\nfont-size: 33px;\nline-height: 29px;\nmargin-bottom: 17px;\n}\n.email-cont{\n    margin-top: 15px;\n}\n\n.forget-pass-input{\n    margin-top: 20px;\n}\n.span-forg{\n    font-family: 'Figtree', sans-serif;\n    font-weight: 500;\n    font-size: 12px;\n    line-height: 29px; \n    color: #2C68A1;\n    margin: 0;\n}\n.google-continue{\ncolor: #2D333A!important;\nfont-family: 'Figtree', sans-serif!important;\nfont-weight: 500!important;\nfont-size: 15px!important;\nline-height: 29px!important; \n}\n.login-pass-outer .email-inner button {\n    margin-top: 10px;\n}\n.comfirm-pass{\n    margin-top: 20px;\n    margin-bottom: 20px;\n} \n.school-outer-pages .css-t3ipsp-control,\n.school-outer-pages .css-13cymwt-control{\n    height: 55px;\n    border-radius: 6px;\nborder: 1px solid #C2C8D0;\npadding-left: 10px;\nmargin-bottom: 20px;\ncolor: rgba(45, 51, 58, 0.45);\nfont-family: \"Figtree\";\nfont-size: 17px;\nfont-style: normal;\nfont-weight: 500;\nline-height: 29px;\n}\n.school-content-page{\n    padding: 15px 40px;\n}\n\n.generate-inner img{\n    width: 15px;\n    height: 15px;\n}\n.generate-inner{\n    display:flex;\n    margin-top: 20px;\n}\n.generate-inner h2{\n    color: #2C68A1;\nfont-family: \"Figtree\";\nfont-size: 13px;\nfont-style: normal;\nfont-weight: 700;\nmargin: 0px 0px 0px 7px;\n}\n.output-container{\n    height: auto;\n    width: 100%;\n    padding: 20px 160px 0 225px;\n}\n.write-question{\nborder-radius: 12px;\nbackground: #F4F4F4;\npadding: 15px 15px 15px 15px;\n}\n.write-question p{\n    font-family: 'Figtree', sans-serif;\n    color: #0D0D0D;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 23px;\n    letter-spacing: 0.45px;\n    margin: 0;\n\n}\n.write-question ol.write-question-list{\n    padding-left: 17px;\n}\n.write-question ol.write-question-list li{\n    color: #0D0D0D;\n    font-family: 'Figtree', sans-serif;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 29px;\n    letter-spacing: 0.45px;\n}\n\n.sidebar-one .sidebar-inner-layout{\n    display: none;\n}\n/* .sidebar.sidebar-one{\n    width: 0;\n}\n.sidebar.sidebar-one.open{\n    width: 25%;\n} */\n.inner-images{\n    display: flex;\n    padding-top: 20px;\n    padding-bottom: 30px;\n}\n.inner-images .dislike-image{\n    width: 18px;\n    height: 18px;\n    margin-left: 12px;\n    margin-top: -1px;   \n}\n.inner-images .group-image{\n    width: 15.456px;\n    height: 15.455px;\n}\n\n\n.input-field-btn textarea{\n    width: 100%;\n    height: 104px;\n    border-radius: 15px;\nborder: 1px solid #DCDCDC;\npadding: 30px 130px 30px 30px;\nbox-shadow: 1px 1px 4px 0px rgba(0, 0, 0, 0.25);\nflex: 1;\n      resize: none;\n        min-height: 95px;\n      max-height: 200px;\n      border: 1px solid #ccc;\n      border-radius: 8px;\n      font-size: 15px;\n      outline: none;\n      overflow-y: auto;\n}\n.input-field-btn{\n    position: relative;\n}\n.input-field-btn button{\n height: 38px;\n    border-radius: 12px;\n    background: #2C68A1;\n    color: #FFF;\n    font-family: 'Figtree', sans-serif;\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 29px;\n    letter-spacing: 0.45px;\n    border: none;\n    bottom: 30px;\n    display: flex;\n    right: 35px;\n    padding: 5px 10px;\n    gap: 5px;\n    justify-content: center;\n}\n.input-field-btn button img{\n    width: 26px;\n    height: 26px;\n}\n.input-text-inner-field{\n    padding-top: 10px;\n}\n\n.input-text-inner-field p{\n    margin: 0;\n    color: #595959;\n\nfont-family: \"Figtree\";\nfont-size: 15px;\nfont-style: normal;\nfont-weight: 400;\nline-height: 29px;\n}\n.buttons-cont-flex{\n    display: flex;\n    margin-top: 20px;\n    margin-bottom: 20px;\n}\n.buttons-cont-flex button{\n    width: 112px;\nheight: 38px;\nborder-radius: 12px;\nborder: 1px solid #2C68A1;\ncolor: #2C68A1;\nfont-family: Figtree;\nfont-size: 14px;\nfont-style: normal;\nfont-weight: 500;\nline-height:17px; \nletter-spacing: 0.42px;\n}\n\n.buttons-cont-flex .assignment{\nmargin-left: 10px;\nmargin-right: 10px;\n}\n.Given-answer{\n    padding: 15px 15px 15px 0px;\n}\n.Given-answer p{\n    margin: 0;\n}\n.school-pages-inner .email-inner .input-container span{\n    position: absolute;\n    right: 15px;\n    bottom: 18px;\n}\n.left-span{\n    margin-left: 70px;\n}\n.high-light-btn {\n    background-color:#3498db !important;\n    color:white !important;\n}\n\n.ScrollBar {\n  height: 70%;\n  overflow-y: auto;\n  padding-right: 10px;\n\n  /* Firefox scrollbar styling */\n  scrollbar-width: none;                    /* Options: auto | thin | none */\n  scrollbar-color: #aaa transparent;        /* Thumb | Track */\n}\n\n/* Chrome, Safari, Edge (WebKit) */\n.ScrollBar::-webkit-scrollbar {\n  width: 0px;\n}\n\n.ScrollBar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.ScrollBar::-webkit-scrollbar-thumb {\n  background-color: #aaa;\n  border-radius: 4px;\n  border: 2px solid transparent; /* Optional for spacing inside track */\n  background-clip: content-box;\n}\n\n\n\n.login-pass-iner-outer .schoo-outer {\n    margin-top: 75px;\n}\n\n.login-pass-iner-outer .signup-outer-pagess h2 {\n    font-size: 29px;\n}\n\n\n\n\n\n\n\n.chat-container {\n      flex: 1;\n      overflow-y: auto;\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n      gap: 15px;\n    }\n\n   \n\n    .input-wrapper {\n      display: flex;\n      padding: 16px;\n      border-top: 1px solid #ddd;\n      background-color: #fff;\n    }\n\n  \n\n\n\n@media screen and (max-width: 480px) {\n    .output-container{\n    padding: 20px;\n}\n.output-container .input-field-btn{\n    position: absolute;\n    bottom: auto;\n}\n.input-field-btn button {\n    bottom: 36px;\n    right: 13px;\n}\n.input-field-btn textarea {\n    padding: 30px 118px 30px 30px;\n}\n\n/* button-login-inner → HomeHeader1.css */\n    .content-inner2 {\n        padding: 0 10px;\n}\n.content-inner2 img {\n    top: 8px;\n}\n}\n@media screen and (max-width: 991px) {\n.output-container .input-field-btn button {\n        right: 58px;\n    }\n    .output-container .input-field-btn {\n        position: absolute;\n        bottom: auto;\n    }\n    .output-container .input-field-btn button {\n    width: 90px;\n    }\n\n\n.output-container {\n    padding: 20px;\n}\n.content-inner2 img {\n    top: 8px;\n}\n.input-field-btn {\n    position: absolute;\n    width: 95%;\n    bottom: 29px;\n}\ndiv.choose-organisaton {\n    width: 100%;\n}\ndiv.organisaton-container {\n    flex-direction: column;\n}\n}\n@media screen and (max-width: 1200px) {\n\n    .output-container .input-field-btn button {\n        right: 58px;\n    }\n    .output-container .input-field-btn {\n        position: absolute;\n        bottom: auto;\n    }\n    .output-container .input-field-btn button {\n    width: 90px;\n    }\n.output-container {\n    padding: 20px;\n}\n.input-field-btn {\n    position: absolute;\n    width: 100%;\n    bottom: 29px;\n}\n.output-outer-content {\n    min-height: calc(100vh - 200px);\n}\n.unit-plan h3 {\n    color: rgba(0, 0, 0, 1);\n    font-family: 'Figtree', sans-serif;\n    font-weight: 600;\n    font-size: 13px;\n    line-height: 29px;\n}\n.content-inner2 {\n    height: 200px;\n    width: 100%;\n    padding: 0 20px;\n}\n.input-field-btn button {\n right: 15px;\n}\n.input-field-btn textarea {\n    padding: 30px 120px 30px 30px;\n}\n/* button-login-inner → HomeHeader1.css */\n}\n\n\n\n/* -------------------Ram------------------ */\n\n/* logomain, logo-scsc.logomain → HomeHeader1.css */\n.welcome-teaching{\n    margin-left: 277px;\n    width: calc(100% - 277px);\n    padding: 27px;\n    background: #2C68A1;\n    color: #fff;\n    border-radius: 6px;\n    max-width: 1350px;\n     font-family: 'Figtree', sans-serif;\n     \n}\n\n.welcome-main-teaching{\n    padding: 20px 20px 0px 20px;\n       flex: 1 1 0%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n\n\n.output-container.output-tft .Given-answer{\n     font-family: 'Figtree', sans-serif;\n    border-radius: 6px;\n    background: #F4F4F4;\n    padding: 15px;\n    margin-bottom: 10px;\n    width: 90%;\n    display: inline-block;\n    box-shadow: 0px 4px 4px 0px #00000040;\n\n}\n\n.output-container.output-tft .write-question {\n    border-radius: 6px;\n    background: #2C68A1;\n    padding: 15px 15px 15px 15px;\n    margin-bottom: 10px;\n    width: 90%;\n    \n}\n .output-container.output-tft .write-question.message-inner{\n    color:#fff\n}\n.output-container.output-tft {\n   padding: 0px 25px;\n}\n.main-conatiner-user{\n    width: 100%;\n    display: inline-flex;\n    justify-content: end;\n}\n.main-conatiner-user .message-inner-div{\n    color:#fff;\n     font-size: 17px;\n    font-weight: 400;\n}\n.main-conatiner-user .message-content-inner{\n     border-radius: 12px;\n    background: #2C68A1;\n    padding: 15px 15px 15px 15px;\n    margin-bottom: 10px;\n    border: 1px solid #DFDFDF;\n   max-width: 90%;\n       color: #fff;\n}\n\n.given-container{\n    max-width: 90%;\n}\n.given-container .message-inner-div {\n    color: rgb(13, 13, 13);\n    font-size: 17px;\n    font-weight: 400;\n}\n\n.given-container .message-inner-div{\n  border-radius: 12px;\n    background: #F4F4F4;\n    padding: 15px;\n    margin-bottom: 10px;\n    display: inline-block;\n    box-shadow: 0px 0px 0px 0px #00000040;\n}\n.output-tft .input-field-btn textarea {\n    width: 90%;\n  min-height: 60px;\n    padding: 10px 40px 10px 20px;\n}\n\n.output-tft .input-field-btn button {\n    width: auto;\n   height: auto;\n    right: 10px;\n    bottom: 10px;\n    padding: 6px 15px;\n    display: flex;\n    justify-content: space-between;\n}\n.output-tft .output-outer-content {\n    min-height: calc(100vh - 135px);\n}\n.given-container .message-content-inner img,\n.given-container .message-content-inner hr{\ndisplay: none;\n}\n\n.welcome-main-teaching {\n    margin-left: 227px;\n}\n/* .output-container.output-tft .message-content-inner ul {\n    margin-bottom: 0;\n} */\n .multipleChoice {\n   min-height: 100vh \n }\n\n.homme-outer-container {\n    height:80vh; \n}\n.homme-outer-containers,\n.homme-outer-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n@media screen and (max-width: 480px) {\n/* logo-scsc.logomain → HomeHeader1.css */\n.welcome-main-teaching {\n    margin-left: 0;\n}\n}\n\n/* ========== TFT Frontend page style here ===========*/\n.tft-front-page {\n padding: 0 40px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    min-height: 100vh;\n    max-width: 1330px;\n    margin: 0 auto;\n    width: 100%;\n    box-sizing: border-box;\n}\n.tft-front-page h2.mb-4 {\n    font-weight: 600;\n    margin-bottom: 24px;\n    color: #2d333a;\n}\n.organisaton-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: start;\n    align-items: stretch;\n    gap: 40px;\n    overflow: hidden;\n    width: 100%;\n}\n.choose-organisaton {\n   padding: 10px 20px;\n    width: 50%;\n    border: 1px solid #cdcdcd;\n     border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    min-height: 226px;\n    box-sizing: border-box;\n    background: #fff;\n}\n\n\n.choose-organisaton-img {\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n}\n\n.choose-organisaton-img.organisation-imag-inne {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 12px;\n    width: 100%;\n    max-width: 100%;\n    min-width: 0;\n}\n\n.choose-organisaton-img.organisation-imag-inne > div:first-child {\n    min-width: 0;\n    flex: 1 1 auto;\n    max-width: 100%;\n}\n\n.wam-coming3d-wrap {\n    flex-shrink: 0;\n}\n\n.wam-coming3d-text {\n    font-size: 18px;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #adabab;\n    padding: 10px 12px;\n    border-radius: 5px;\n    border: 1px solid #cdcdcd;\n    margin: 0;\n    white-space: nowrap;\n}\n\n.choose-organisaton:hover .wam-coming3d-text {\n    color: #1c5499;\n    border: 1px solid #1c5499;\n}\n\n.choose-organisaton img {\n  max-width: min(350px, 100%);\n  height: auto;\n  display: block;\n  width: auto;\n  position: relative;\n  object-fit: contain;\n}\n.organisation-text-info {\n    min-height: 89px;\n    flex: 1;\n}\n.organisation-text-info p {\n    margin: 0;\n    color: #2d333a;\n    line-height: 1.5;\n}\n.choose-organisaton button {\n    min-width: 130px;\n    margin-top: auto;\n    align-self: flex-start;\n    background-color: #fff;\n    color: #212529;\n}\n.choose-organisaton button .fa {\n    font-size: 11px;\n}\n.choose-organisaton:hover button {\n      background: rgba(44, 104, 161, 1);\n      color: #fff;\n}\n    .choose-organisaton:hover {\n    cursor: pointer;\n    border:1px solid rgba(44, 104, 161, 1);\n    box-shadow: 0 8px 15px rgba(0,0,0,0.2); \n    }\n    .choose-organisaton-coming-soon:hover {\n    cursor: default;\n    }\n\n@media screen and (max-width: 480px) {\n    .choose-organisaton {\n        min-height: 226px!important;\n    }\n\n    .organisation-text-info {\n        min-height: auto;\n        flex: 0 0 auto;\n    }\n\n    .choose-organisaton:not(.choose-organisaton-coming-soon) .choose-organisaton-img img {\n        max-width: 72%;\n        width: auto;\n    }\n\n    .choose-organisaton-img.organisation-imag-inne > div:first-child {\n        flex: 1 1 68%;\n    }\n\n    .choose-organisaton-img.organisation-imag-inne > div:first-child img {\n        max-width: 100%;\n        width: 100%;\n    }\n\n    .choose-organisaton-img.organisation-imag-inne .wam-coming3d-text {\n        font-size: 8px;\n        padding: 5px 8px;\n    }\n}\n\n    .spaceTopBottom {\n    margin-top: 15px;\n    margin-bottom: 16px;\n    }\n    .scsbc-chartboart {\n    max-width:550px;\n    width: 100%;\n    margin: 0 auto;\n    /* border:1px solid hsl(214.3 31.8% 91.4%);\n    box-shadow: 0px 2px 5px 2px #e2e8f0; */\n    padding:10px 20px 20px 20px;\n    border-radius: 8px;\n    }\n    .learning-supports-full-width.scsbc-chartboart {\n    max-width: 75%;\n    width: 75%;\n    }\n    .twice-btn{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    padding-top: 25px;\n    }\n    \n    .twice-btn .btn {\n    background-color: rgba(44, 104, 161, 1);\n    color: rgba(255, 255, 255, 1);\n    min-width: 115px;\n    padding: 8px 15px 9px 15px;\n    border-radius: 12px;\n    }\n    .unit-plan:hover, \n    .twice-btn .btn:hover {\n    border:1px solid hsl(214.3 31.8% 91.4%);\n    box-shadow: 0px 2px 5px 2px #e2e8f0;\n    background: transparent;\n    color:#000;\n    }\n\n\n    .afterchatbot .output-tft .input-field-btn textarea {\n    line-height: 35px;\n    }\n\n    /* .afterchatbot .home-page-content-inner .output-tft .input-field-btn textarea {\n    width: 100%;\n    min-height: 60px;\n    padding: 10px 20px;\n    max-width: 87%;\n    }\n\n    .afterchatbot .inner-images-content {\n    padding: 10px 0px 60px 0;\n    }\n\n  \n    .afterchatbot .home-page-content-inner .output-tft .input-field-btn {\n        width: 100%;\n    }\n    .afterchatbot .output-tft .input-field-btn button {\n    bottom: -51px!important;\n    }\n    .afterchatbot .output-tft .input-field-btn {\n    display: flex;\n    gap: 0px;\n    }\n    .afterchatbot .output-tft .input-field-btn button {\n    right: 0;\n    } */\n \n    .afterchatbot .given-container .message-inner-div{\n    margin-bottom: 0;\n    }\n      .afterchatbot .home-page-content-inner .output-tft .input-field-btn textarea {\n    width: 100%;\n    max-width: 100%;\n    }\n    .afterchatbot .given-container .message-inner-div {\n    padding: 15px 15px 30px 15px;\n    }\n    .afterchatbot .given-container .message-content-inner .group-image{\n    width: 18px!important;\n    height: 18px !important;\n    position: relative;\n    bottom: 33px;\n    left: 25px;\n    }\n\n    @media only screen and (max-width: 480px) {\n    .afterchatbot .inner-images-content {\n    padding: 10px 0px 44px 0;\n    }\n    .afterchatbot .home-page-content-inner .output-tft .input-field-btn textarea {\n    width: 95%;\n    max-width: 100%;\n    }\n    .afterchatbot .home-page-content-inner .output-tft .input-field-btn {\n        width: 100%;\n    }\n    .afterchatbot .output-tft .input-field-btn button {\n    width: 69px;\n    height: 35px;\n    bottom: -45px!important;\n    }\n    .afterchatbot .output-tft .translate-inn{\n    transform: translateY(0%)!important;\n    }\n    .afterchatbot .output-tft .input-field-btn {\n    display: flex;\n    gap: 0px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
